/* =====================================================================
   Rejuveen / KeraLush Hair Diagnostic Quiz... vanilla JS port.

   Mounted into #keralush-quiz-root. Reads window.KERALUSH_CFG (populated
   by the Liquid section) for image URLs and variant IDs.

   State machine: intro -> 11 questions interleaved with 3 education
   inserts -> analyze -> results (which embeds a 3-step offer flow).

   Cart flow is a permalink chain (/cart/clear?return_to=/cart/add?...&return_to=/checkout)
   matching the subscription pattern in sections/price-table.liquid. Quiz
   answers ride along as line-item properties on the /cart/add step so they
   surface under the line item on the Shopify Admin order.

   Tracking calls go to fbq, gtag, and Klaviyo _learnq if present (the
   theme is expected to define those globals before this file loads).
===================================================================== */
(function () {
  'use strict';

  var CFG = window.KERALUSH_CFG || {};
  var localImgs = CFG.images || {};
  var VARIANTS = CFG.variants || {
    bundle90: 46416449437858,
    bundle60: 46416449470626,
    bundle30: 46416449503394,
  };

  /* ============== IMAGE URL MAP ============== */
  var IMG = {
    bundle_3: localImgs.bundle_3 || '',
    bundle_2: localImgs.bundle_2 || '',
    bundle_1: localImgs.bundle_1 || '',
    ig_keratin: 'https://rejuveen.com/cdn/shop/files/Ingredients_Keratin.jpg?v=1765775369&width=1080',
    ig_ashwagandha: 'https://rejuveen.com/cdn/shop/files/Ingredients_Ashwagandha.jpg?v=1765775433&width=1080',
    ig_zeropollution: 'https://rejuveen.com/cdn/shop/files/Ingredients_Zeropollution.jpg?v=1765775495&width=1080',
    ig_biotin: localImgs.ig_biotin || '',
    ig_pantothenic: localImgs.ig_pantothenic || '',
    ig_zinc: localImgs.ig_zinc || '',
    ig_copper: localImgs.ig_copper || '',
    ig_vitamin_c: localImgs.ig_vitamin_c || '',
    ig_vitamin_e: localImgs.ig_vitamin_e || '',
    ig_vitamins: localImgs.ig_vitamin_c || '',
    bottle: localImgs.bottle || '',
    megan: localImgs.megan || '',
    x_mark: localImgs.x_mark || '',
    life_chart: 'https://assets.replocdn.com/projects/513afab3-e71a-4fc2-9c15-01cfc57893d5/0f74bac2-aae6-455a-a2d1-36eb7de64341',
    life_anchor: 'https://assets.replocdn.com/projects/513afab3-e71a-4fc2-9c15-01cfc57893d5/18924535-49ff-4f89-81ae-4d5a86035c28',
    life_bottle_hair: 'https://assets.replocdn.com/projects/513afab3-e71a-4fc2-9c15-01cfc57893d5/a0f74aae-abc8-432c-a848-c4d804910ec2',
    trig_1: 'https://rejuveen.com/cdn/shop/files/1_1b22c470-fab8-42fc-a969-7a708c339262_720x.png?v=1765773001',
    trig_4: 'https://rejuveen.com/cdn/shop/files/4_2acb95fb-98a0-419e-a2f4-59680724fd70_720x.png?v=1765773373',
    trig_5: 'https://rejuveen.com/cdn/shop/files/5_232a2ff7-cdf9-4c44-9e60-fadd29b0a805_720x.png?v=1765773473',
    ba_1: 'https://assets.replocdn.com/projects/4e13795c-0403-4afc-85ac-760dea33ba91/15c9e3df-ab5d-4307-a9e6-d3ff38800f7e',
    ba_2: 'https://assets.replocdn.com/projects/4e13795c-0403-4afc-85ac-760dea33ba91/373b9e60-8e9e-4d74-9614-29ce95d9bc1e',
    ba_3: 'https://assets.replocdn.com/projects/4e13795c-0403-4afc-85ac-760dea33ba91/f58b6c35-ff01-4d80-b4d7-34c720b73a06',
    ba_4: 'https://assets.replocdn.com/projects/4e13795c-0403-4afc-85ac-760dea33ba91/39de4c0e-f965-4906-9b02-573a8ad21e55',
    port_1: 'https://assets.replocdn.com/projects/513afab3-e71a-4fc2-9c15-01cfc57893d5/e772dc1d-792f-4bbd-ac4b-f72e42d3f9f1',
    port_2: 'https://assets.replocdn.com/projects/513afab3-e71a-4fc2-9c15-01cfc57893d5/96b703db-c77c-45ca-a68f-fec8f27ccc02',
    port_3: 'https://assets.replocdn.com/projects/513afab3-e71a-4fc2-9c15-01cfc57893d5/51a0d619-58b5-4566-8cda-45eef2c6afd1',
    port_4: 'https://assets.replocdn.com/projects/513afab3-e71a-4fc2-9c15-01cfc57893d5/1f32fe8f-da8f-44af-b000-9200ea9ea644',
    money_back: 'https://rejuveen.com/cdn/shop/files/money_back.png?v=1747364788&width=1080',
    intro_ba_hero: localImgs.intro_ba_hero || '',
    sleep_hair: localImgs.sleep_hair || '',
    ozempic_pen: localImgs.ozempic_pen || '',
    shower_ba: localImgs.shower_ba || '',
    weight_ba: localImgs.weight_ba || '',
    cortisol_density: localImgs.cortisol_density || '',
  };

  /* ============== QUIZ DATA ============== */
  var QUESTIONS = [
    {
      id: 'glp1', kind: 'radio', eyebrow: 'Question 01 · Your medication',
      title: 'Which <em>weight-loss medication</em> are you on?',
      sub: 'We tailor your protocol based on the specific cortisol and nutrient pathways your medication disrupts.',
      imageHero: IMG.ozempic_pen,
      heroTransparent: true,
      options: [
        { v: 'ozempic', label: 'Ozempic', tag: 'semaglutide · 2.5\u00d7 hair loss risk' },
        { v: 'wegovy', label: 'Wegovy', tag: 'semaglutide · 2.5\u00d7 risk' },
        { v: 'mounjaro', label: 'Mounjaro', tag: 'tirzepatide · 1.7\u00d7 risk' },
        { v: 'zepbound', label: 'Zepbound', tag: 'tirzepatide · 1.7\u00d7 risk' },
        { v: 'other', label: 'Other / compounded', tag: 'still at elevated risk' },
      ],
    },
    {
      id: 'duration', kind: 'radio', eyebrow: 'Question 02 · Timeline',
      title: 'How long have you been <em>on the shot?</em>',
      sub: 'Shedding typically peaks 3\u20136 months after you start. Knowing where you are matters.',
      options: [
        { v: 'lt3', label: 'Less than 3 months', tag: 'pre-shedding window' },
        { v: '3to6', label: '3\u20136 months', tag: 'peak risk phase' },
        { v: '6to12', label: '6\u201312 months', tag: 'chronic phase' },
        { v: 'gt12', label: 'Over a year', tag: 'long-term protocol' },
      ],
    },
    {
      id: 'shedding', kind: 'severity', eyebrow: 'Question 03 · Severity',
      title: 'How much hair comes out <em>in the shower</em>?',
      sub: "Be honest. 50\u2013100 hairs a day is normal. We're looking for clumps.",
      imageHero: IMG.shower_ba,
      scale: [
        { v: 1, label: 'Normal' },
        { v: 2, label: 'A bit more' },
        { v: 3, label: 'Noticeable' },
        { v: 4, label: 'Handfuls' },
        { v: 5, label: 'Clumps' },
      ],
    },
    {
      id: 'pillow', kind: 'radio', eyebrow: 'Question 04 · Visible signs',
      title: 'What do you see <em>on your pillow</em> every morning?',
      options: [
        { v: 'a', label: 'Almost nothing', tag: '' },
        { v: 'b', label: 'A few strands', tag: '' },
        { v: 'c', label: 'Enough that I notice daily', tag: '' },
        { v: 'd', label: 'I stopped looking', tag: 'we hear you' },
      ],
    },
    {
      id: 'part', kind: 'radio', eyebrow: 'Question 05 · Thinning pattern',
      title: 'Has your <em>part</em> gotten wider?',
      sub: "Or ponytail thinner, or temples patchier... anywhere you've noticed loss of density.",
      imageHero: IMG.ba_3,
      options: [
        { v: 'no', label: 'No, density feels the same', tag: '' },
        { v: 'slight', label: 'Slightly... could be in my head', tag: '' },
        { v: 'yes', label: 'Yes, clearly wider', tag: '' },
        { v: 'alot', label: 'Dramatically... I can see scalp', tag: 'urgent' },
      ],
    },
    {
      id: 'age', kind: 'pills', eyebrow: 'Question 06 · Life stage',
      title: "What's your <em>age range?</em>",
      sub: 'Estrogen, cortisol, and follicle-anchor proteins all shift with age.',
      options: [
        { v: '25-34', big: '25\u201334', small: 'pre-peri' },
        { v: '35-44', big: '35\u201344', small: 'perimeno' },
        { v: '45-54', big: '45\u201354', small: 'meno' },
        { v: '55+', big: '55+', small: 'post-meno' },
      ],
    },
    {
      id: 'weight', kind: 'radio', eyebrow: 'Question 07 · Your progress',
      title: 'How much weight have you <em>lost so far?</em>',
      sub: 'Rapid weight loss releases stored toxins into your bloodstream. We account for that.',
      imageHero: IMG.weight_ba,
      options: [
        { v: '<15', label: 'Under 15 lbs', tag: 'mild toxin release' },
        { v: '15-30', label: '15\u201330 lbs', tag: 'moderate release' },
        { v: '30-50', label: '30\u201350 lbs', tag: 'significant release' },
        { v: '50+', label: 'Over 50 lbs', tag: 'maximum toxin load' },
      ],
    },
    {
      id: 'stress', kind: 'radio', eyebrow: 'Question 08 · Cortisol load',
      title: "How's your <em>stress</em> right now?",
      sub: 'Cortisol blocks GAS6... the molecule that tells follicles to stay in growth mode.',
      imageHero: IMG.cortisol_density,
      options: [
        { v: 1, label: 'Manageable', tag: 'baseline' },
        { v: 2, label: 'Moderate', tag: '' },
        { v: 3, label: 'High', tag: '' },
        { v: 4, label: 'Through the roof', tag: 'cortisol surge' },
      ],
    },
    {
      id: 'sleep', kind: 'radio', eyebrow: 'Question 09 · Recovery',
      title: "How's your <em>sleep?</em>",
      sub: 'Follicles rebuild keratin during deep sleep. Poor sleep = weaker hair.',
      beforeAfter: true,
      options: [
        { v: 'good', label: '7+ hrs, sleeping deeply', tag: '' },
        { v: 'ok', label: '6\u20137 hrs, decent', tag: '' },
        { v: 'broken', label: 'I wake up during the night', tag: '' },
        { v: 'bad', label: 'Less than 6 hrs / exhausted', tag: '' },
      ],
    },
    {
      id: 'tried', kind: 'chips', eyebrow: "Question 10 · What you've tried",
      title: 'What have you <em>already tried?</em>',
      sub: 'Select any. Most single-ingredient solutions only address 1 of the 5 triggers.',
      options: [
        { v: 'biotin', label: 'Biotin' },
        { v: 'collagen', label: 'Collagen' },
        { v: 'minoxidil', label: 'Minoxidil (topical)' },
        { v: 'supplement', label: 'A hair growth supplement' },
        { v: 'shampoo', label: 'Thickening shampoos' },
        { v: 'rosemary', label: 'Rosemary oil' },
        { v: 'topical', label: 'Scalp serums' },
        { v: 'nothing', label: 'Nothing yet' },
      ],
    },
    {
      id: 'goal', kind: 'radio', eyebrow: 'Question 11 · Your goal',
      title: "What's your <em>#1 goal?</em>",
      sub: "We'll personalize your 90-day protocol around this.",
      imageHero: IMG.ba_2,
      options: [
        { v: 'stop-shed', label: 'Stop the shedding... NOW', tag: 'urgent protocol' },
        { v: 'regrow', label: "Regrow what I've lost", tag: '90-day track' },
        { v: 'thicken', label: 'Thicker, fuller hair', tag: 'density track' },
        { v: 'keep-shot', label: 'Keep my results without the hair loss', tag: 'protect + restore' },
      ],
    },
  ];

  var EDUCATION = {
    stat1: {
      badge: 'RESEARCH INSERT',
      label: 'The risk is real.',
      num: 2.5, suffix: '\u00d7',
      cap: 'higher risk of significant hair loss with semaglutide vs. non-users.',
      source: 'Peer-reviewed cohort analysis, 1,922 weight-loss medication users (2024). Tirzepatide carries a 1.7\u00d7 elevated risk.',
      image: IMG.life_chart,
    },
    stat2: {
      badge: 'THE MECHANISM',
      label: 'Why "the shot" steals hair.',
      image: IMG.life_bottle_hair,
      triggers: [
        { n: 1, name: 'Toxin Tsunami', txt: 'Rapid fat loss dumps stored toxins into your bloodstream... oxidative chaos for follicles.', img: IMG.trig_1 },
        { n: 2, name: 'Nutrient Starvation', txt: 'Reduced appetite = your follicles, nails, skin starve first. Iron, zinc, protein, biotin diverted away.', img: IMG.trig_4 },
        { n: 3, name: 'Cortisol Surge', txt: 'Rapid body change = stress. Cortisol blocks GAS6 signaling. Follicles get stuck in resting phase.', img: IMG.trig_1 },
        { n: 4, name: 'Muscle Inflammation', txt: 'Up to 40% of GLP-1 weight loss can come from muscle, not fat. The lost lean mass releases inflammatory signals that attack hair anchor proteins (COL17A1).', img: IMG.life_anchor },
        { n: 5, name: 'Anchor Breakdown', txt: 'The microscopic roots holding each strand weaken. Healthy-looking hair just\u2026 slides out.', img: IMG.trig_5 },
      ],
    },
    stat3: {
      badge: 'CLINICAL EVIDENCE',
      num: 43.1, suffix: '%',
      cap: 'reduction in hair loss in 60 days with keraGEN-IV\u00ae keratin peptides.',
      source: 'Randomized, double-blind, placebo-controlled clinical trial. 65 women. Peer-reviewed.',
      extra: '17.6% stronger strands · Measured via birefringence analysis',
      image: IMG.ig_keratin,
    },
  };

  /* ============== PACKAGES ============== */
  var PACKAGES = [
    { k: '90', months: '90-Day Supply', bottles: 3, per: '$2.30', total: 207, strike: 297, save: 30, badge: 'BEST VALUE', bundle: IMG.bundle_3, variantId: VARIANTS.bundle90, url: '/cart/' + VARIANTS.bundle90 + ':1' },
    { k: '60', months: '60-Day Supply', bottles: 2, per: '$2.47', total: 148, strike: 198, save: 25, badge: 'POPULAR', bundle: IMG.bundle_2, variantId: VARIANTS.bundle60, url: '/cart/' + VARIANTS.bundle60 + ':1' },
    { k: '30', months: '30-Day Supply', bottles: 1, per: '$2.63', total: 79, strike: 99, save: 20, badge: null, bundle: IMG.bundle_1, variantId: VARIANTS.bundle30, url: '/cart/' + VARIANTS.bundle30 + ':1' },
  ];

  /* ============== STEPS ============== */
  var STEPS = [
    { type: 'intro' },
    { type: 'q', idx: 0 },
    { type: 'q', idx: 1 },
    { type: 'edu1' },
    { type: 'q', idx: 2 },
    { type: 'q', idx: 3 },
    { type: 'q', idx: 4 },
    { type: 'edu2' },
    { type: 'q', idx: 5 },
    { type: 'q', idx: 6 },
    { type: 'q', idx: 7 },
    { type: 'edu3' },
    { type: 'q', idx: 8 },
    { type: 'q', idx: 9 },
    { type: 'q', idx: 10 },
    { type: 'analyze' },
    { type: 'results' },
  ];

  /* ============== STORAGE ============== */
  var safeLS = (function () {
    try {
      var t = '__klt__';
      localStorage.setItem(t, '1');
      localStorage.removeItem(t);
      return {
        get: function (k) { return localStorage.getItem(k); },
        set: function (k, v) { localStorage.setItem(k, v); },
      };
    } catch (e) {
      var mem = {};
      return {
        get: function (k) { return Object.prototype.hasOwnProperty.call(mem, k) ? mem[k] : null; },
        set: function (k, v) { mem[k] = String(v); },
      };
    }
  })();

  var state = {
    step: 0,
    answers: {},
    plan: '90',
    offerStep: 1,
    flippedTrigger: null,
  };

  (function loadState() {
    var s = parseInt(safeLS.get('kl_step') || '0', 10);
    if (isNaN(s) || s < 0) s = 0;
    if (s >= STEPS.length) s = STEPS.length - 1;
    state.step = s;
    try {
      state.answers = JSON.parse(safeLS.get('kl_answers') || '{}') || {};
    } catch (e) { state.answers = {}; }
  })();

  function persistState() {
    safeLS.set('kl_step', String(state.step));
    safeLS.set('kl_answers', JSON.stringify(state.answers));
  }

  /* ============== TRACKING ============== */
  var STANDARD_PIXEL_EVENTS = { Lead: 1, AddToCart: 1, InitiateCheckout: 1 };
  var GA4_EVENT_MAP = {
    QuizStart: 'quiz_start',
    QuizComplete: 'quiz_complete',
    Lead: 'generate_lead',
    AddToCart: 'add_to_cart',
    InitiateCheckout: 'begin_checkout',
  };

  function track(name, params) {
    params = params || {};
    try {
      if (typeof window.fbq === 'function') {
        if (STANDARD_PIXEL_EVENTS[name]) window.fbq('track', name, params);
        else window.fbq('trackCustom', name, params);
      }
      if (typeof window.gtag === 'function') {
        window.gtag('event', GA4_EVENT_MAP[name] || name, params);
      }
    } catch (err) { /* swallow */ }
  }

  function klaviyoIdentify(props) {
    try {
      window._learnq = window._learnq || [];
      window._learnq.push(['identify', props]);
    } catch (err) { /* swallow */ }
  }

  var LEAD_FIRED_KEY = 'kl_lead_fired';
  function hasLeadFired() {
    try { return sessionStorage.getItem(LEAD_FIRED_KEY) === '1'; }
    catch (e) { return false; }
  }
  function markLeadFired() {
    try { sessionStorage.setItem(LEAD_FIRED_KEY, '1'); }
    catch (e) { /* swallow */ }
  }

  /* ============== HELPERS ============== */
  function esc(str) {
    if (str == null) return '';
    return String(str).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  function imgTag(src, alt, attrs) {
    if (!src) return '';
    attrs = attrs || {};
    var attrStr = '';
    for (var k in attrs) {
      if (attrs[k] != null) attrStr += ' ' + k + '="' + esc(attrs[k]) + '"';
    }
    return '<img src="' + esc(src) + '" alt="' + esc(alt || '') + '" loading="' + (attrs.loading || 'lazy') + '"' + attrStr + '>';
  }

  function getRoot() {
    return document.getElementById('keralush-quiz-root');
  }

  /* On mobile, `.phone-frame` has its own inner scroll. On desktop the
     responsive layer flips it to `overflow: visible` and the page itself
     scrolls instead, so .scrollTo() on the frame becomes a no-op. These
     helpers detect which container is actually scrollable and target it. */
  function frameIsScrollable(frame) {
    if (!frame) return false;
    return frame.scrollHeight > frame.clientHeight + 1;
  }

  function scrollToTop() {
    var frame = document.querySelector('#keralush-quiz-root .phone-frame');
    var body = document.querySelector('#keralush-quiz-root .quiz-body');
    if (frame) frame.scrollTop = 0;
    if (body) body.scrollTop = 0;
    /* Desktop layout: scroll the page to the start of the quiz section
       (not the very top of the document) so any host-theme content above
       the section stays in view. Falls back to (0, 0) if scrollIntoView
       isn't available. */
    var root = document.getElementById('keralush-quiz-root');
    if (root && typeof root.scrollIntoView === 'function') {
      root.scrollIntoView({ block: 'start' });
    } else {
      window.scrollTo(0, 0);
    }
  }

  function scrollToId(id, offset) {
    var elTarget = document.getElementById(id);
    if (!elTarget) return;
    if (offset == null) offset = id === 'offer-anchor' ? 12 : 60;

    var frame = document.querySelector('#keralush-quiz-root .phone-frame');
    if (frameIsScrollable(frame)) {
      var target = elTarget.getBoundingClientRect().top - frame.getBoundingClientRect().top + frame.scrollTop - offset;
      frame.scrollTo({ top: target, behavior: 'smooth' });
      return;
    }

    /* Desktop: window is the scroll container. Convert the target's
       viewport-relative top into a page Y and smooth-scroll the window. */
    var rect = elTarget.getBoundingClientRect();
    var pageY = rect.top + (window.pageYOffset || document.documentElement.scrollTop || 0) - offset;
    if (typeof window.scrollTo === 'function') {
      try {
        window.scrollTo({ top: pageY, behavior: 'smooth' });
      } catch (err) {
        window.scrollTo(0, pageY);
      }
    }
  }

  function updateOfferStep() {
    var profile = computeProfile(state.answers);
    var content = document.querySelector('#keralush-quiz-root .offer-step-content');
    if (!content) {
      render();
      setTimeout(function () { scrollToId('offer-anchor'); }, 50);
      return;
    }
    content.innerHTML = viewOfferStep(state.offerStep, profile);

    var stepNodes = document.querySelectorAll('#keralush-quiz-root .offer-progress .op-step');
    for (var i = 0; i < stepNodes.length; i++) {
      var n = i + 1;
      var node = stepNodes[i];
      node.classList.toggle('active', state.offerStep >= n);
      node.classList.toggle('current', state.offerStep === n);
      var num = node.querySelector('.op-num');
      if (num) num.textContent = state.offerStep > n ? '\u2713' : String(n);
    }

    persistState();
    scrollToId('offer-anchor');
  }

  /* ============== INTRO VIEW ============== */
  function viewIntro() {
    return [
      '<div class="quiz-shell intro-shell">',
      '  <div class="quiz-body">',
      '    <div class="hero">',
      '      <div style="position:relative;z-index:2">',
      '        <div class="hero-pre"><span class="dot">\u25cf</span> FOR WOMEN ON OZEMPIC \u00b7 WEGOVY \u00b7 MOUNJARO \u00b7 ZEPBOUND</div>',
      '        <h1 class="hero-title hero-title-v2">Stop the shed.<br><em>Without quitting the shot.</em></h1>',
      '        <div class="hero-poster hero-poster-v2">',
      IMG.intro_ba_hero ? imgTag(IMG.intro_ba_hero, 'Before and after... hair restored after GLP-1 shedding', { loading: 'eager', fetchpriority: 'high', decoding: 'sync' }) : '',
      '          <span class="corner-tag corner-tag-l">WEEK 1</span>',
      '          <span class="corner-tag corner-tag-r">WEEK 18</span>',
      '          <div class="overlay overlay-3line">',
      '            <div class="cap-1">"My hair came back."</div>',
      '            <div class="cap-2">(I\'m still down 52 lbs.)</div>',
      '            <div class="cap-3">DANA R. \u00b7 9 MONTHS ON WEGOVY</div>',
      '          </div>',
      '        </div>',
      '        <div class="unified-card">',
      '          <p class="uc-prop">In 90 seconds, find out which of the <strong class="hl-orange">7 GLP-1 hair triggers</strong> are behind your shed... and the protocol to reverse it without going off your shot.</p>',
      '          <p class="uc-prop-italic">Built around your medication, your dose, and your shedding pattern.</p>',
      '          <div class="quiz-preview">',
      '            <div class="qp-label">Q1 OF 9 \u00b7 ~90 SECONDS</div>',
      '            <div class="qp-bar"><div class="qp-fill"></div></div>',
      '            <div class="qp-question">Which GLP-1 are you on?</div>',
      '          </div>',
      '          <button class="btn-primary uc-cta" data-action="start">REVEAL MY HAIR-LOSS TRIGGERS <span class="arrow">\u2192</span></button>',
      '          <div class="uc-trust">Private \u00b7 No email to see your results \u00b7 Formulated with trichologists</div>',
      '        </div>',
      '        <div class="cred-strip">',
      '          <div class="cred-col"><div class="cred-num">43.1%</div><div class="cred-lbl">Less hair fall in 60 days</div><div class="cred-src">Clinical, keraGEN-iV\u2122</div></div>',
      '          <div class="cred-col"><div class="cred-num">66%</div><div class="cred-lbl">Cortisol reduction in 60 days</div><div class="cred-src">Clinical, Shoden\u00ae Ashwagandha</div></div>',
      '          <div class="cred-col"><div class="cred-num">Zero</div><div class="cred-lbl">Known GLP-1 interactions</div><div class="cred-src">Reviewed by endocrine RNs</div></div>',
      '        </div>',
      '      </div>',
      '    </div>',
      '  </div>',
      '  <button class="sticky-cta" data-action="start" hidden>START THE 90-SECOND QUIZ <span class="arrow">\u2192</span></button>',
      '</div>',
    ].join('');
  }

  /* ============== QUESTION VIEW ============== */
  function viewQuestion(q, idx, total) {
    var value = state.answers[q.id];
    var progress = (idx + 1) / total * 100;
    var canContinue = q.kind === 'chips' ? (value && value.length > 0) : (value !== undefined && value !== null);
    var autoAdvance = q.kind !== 'chips';
    var optionsHtml = '';
    if (q.kind === 'radio') {
      optionsHtml = '<div class="options">' + q.options.map(function (o, i) {
        var sel = value === o.v;
        return '<button class="option' + (sel ? ' selected' : '') + '" data-action="answer-radio" data-value="' + esc(o.v) + '" style="animation-delay:' + (i * 60) + 'ms">' +
          '<span class="label"><div>' + esc(o.label) + '</div>' + (o.tag ? '<div class="tag">' + esc(o.tag) + '</div>' : '') + '</span>' +
          '<span class="check">' + (sel ? '\u2713' : '') + '</span>' +
          '</button>';
      }).join('') + '</div>';
    } else if (q.kind === 'severity') {
      optionsHtml = '<div class="severity">' + q.scale.map(function (s) {
        var sel = value === s.v;
        return '<button class="severity-cell' + (sel ? ' selected' : '') + '" data-action="answer-severity" data-value="' + esc(s.v) + '">' +
          '<span class="sev-num">' + esc(s.v) + '</span><span class="sev-label">' + esc(s.label) + '</span></button>';
      }).join('') + '</div>' +
        '<div style="display:flex;justify-content:space-between;font-family:var(--mono);font-size:10px;color:var(--ink-3);margin-top:12px;letter-spacing:.14em;text-transform:uppercase">' +
        '<span>Normal</span><span>Severe</span></div>';
    } else if (q.kind === 'pills') {
      optionsHtml = '<div class="pills">' + q.options.map(function (o) {
        var sel = value === o.v;
        return '<button class="pill' + (sel ? ' selected' : '') + '" data-action="answer-pills" data-value="' + esc(o.v) + '">' +
          '<span class="big">' + esc(o.big) + '</span><span class="small">' + esc(o.small) + '</span></button>';
      }).join('') + '</div>';
    } else if (q.kind === 'chips') {
      var arr = value || [];
      optionsHtml = '<div class="chips">' + q.options.map(function (o) {
        var on = arr.indexOf(o.v) !== -1;
        return '<button class="chip' + (on ? ' selected' : '') + '" data-action="answer-chip" data-value="' + esc(o.v) + '">' +
          esc(o.label) + (on ? ' <span class="x">\u2713</span>' : '') + '</button>';
      }).join('') + '</div>';
    }

    var heroHtml = '';
    if (q.imageHero) {
      heroHtml = '<div class="q-hero-img' + (q.heroTransparent ? ' is-floating' : '') + '">' +
        imgTag(q.imageHero, '', { style: 'object-fit:contain' }) + '</div>';
    } else if (q.beforeAfter) {
      heroHtml = '<div class="q-sleep-hero">' +
        imgTag(IMG.sleep_hair, 'Hair shed on pillow after sleep') +
        '<div class="q-sleep-cap">Hair on the pillow \u00b7 every morning</div></div>';
    }

    /* Mirror the React reference: the desktop two-column layout keys off a
       `.has-hero` modifier on the screen wrapper so we don't depend on
       browser :has() support. Floating heroes stay full-width, so they
       don't get the modifier. */
    var hasHero = (q.imageHero && !q.heroTransparent) || q.beforeAfter;

    return [
      '<div class="quiz-shell">',
      '  <div class="top-bar">',
      '    <button class="back-btn" data-action="back">\u2190 Back</button>',
      '    <div class="brand"><em>rejuveen</em></div>',
      '    <button class="skip-btn" data-action="next">Skip</button>',
      '  </div>',
      '  <div class="progress-wrap">',
      '    <div class="progress-meta"><span>' + esc(q.eyebrow) + '</span><span>' + (idx + 1) + ' / ' + total + '</span></div>',
      '    <div class="progress-bar"><div class="progress-fill" style="width:' + progress + '%"></div></div>',
      '  </div>',
      '  <div class="quiz-body">',
      '    <div class="screen' + (hasHero ? ' has-hero' : '') + '" data-screen-label="Q' + String(idx + 1).padStart(2, '0') + '">',
      heroHtml,
      '      <h1 class="q-title">' + q.title + '</h1>',
      q.sub ? '<p class="q-sub">' + esc(q.sub) + '</p>' : '',
      optionsHtml,
      '    </div>',
      '  </div>',
      '  <div class="quiz-footer">',
      (q.kind === 'chips' && !canContinue) ? '<div class="footer-hint">Select at least one option</div>' : '',
      '    <button class="btn-primary" data-action="next"' + (canContinue ? '' : ' disabled') + '>' +
        (autoAdvance ? 'Skip to next' : 'Continue') + ' <span class="arrow">\u2192</span></button>',
      '  </div>',
      '</div>',
    ].join('');
  }

  /* ============== EDU STAT ============== */
  function viewEduStat(data, idx, total) {
    var progress = (idx + 0.5) / total * 100;
    return [
      '<div class="quiz-shell">',
      '  <div class="top-bar">',
      '    <button class="back-btn" data-action="back">\u2190 Back</button>',
      '    <div class="brand"><em>rejuveen</em></div>',
      '    <span style="width:30px"></span>',
      '  </div>',
      '  <div class="progress-wrap">',
      '    <div class="progress-meta"><span>Insight</span><span>...</span></div>',
      '    <div class="progress-bar"><div class="progress-fill" style="width:' + progress + '%"></div></div>',
      '  </div>',
      '  <div class="quiz-body">',
      '    <div class="edu">',
      '      <div class="edu-badge"><span class="dot"></span>' + esc(data.badge) + '</div>',
      '      <h1 class="q-title" style="font-size:26px">' + (data.label || '') + '</h1>',
      data.image ? '<div class="edu-hero-img">' + imgTag(data.image, '', { style: 'object-fit:contain' }) + '</div>' : '',
      '      <div class="stat-hero" data-count-target="' + data.num + '">0<span class="pct">' + esc(data.suffix) + '</span></div>',
      '      <div class="stat-cap">' + esc(data.cap) + '</div>',
      '      <div class="stat-source">' + esc(data.source) + '</div>',
      data.extra ? '<div class="stat-source" style="border-top:none;padding-top:6px;color:var(--orange);font-weight:600">' + esc(data.extra) + '</div>' : '',
      '    </div>',
      '  </div>',
      '  <div class="quiz-footer">',
      '    <button class="btn-primary" data-action="next">I want to know more <span class="arrow">\u2192</span></button>',
      '  </div>',
      '</div>',
    ].join('');
  }

  /* ============== EDU TRIGGERS ============== */
  function viewEduTriggers(data, idx, total) {
    var progress = (idx + 0.5) / total * 100;
    return [
      '<div class="quiz-shell">',
      '  <div class="top-bar">',
      '    <button class="back-btn" data-action="back">\u2190 Back</button>',
      '    <div class="brand"><em>rejuveen</em></div>',
      '    <span style="width:30px"></span>',
      '  </div>',
      '  <div class="progress-wrap">',
      '    <div class="progress-meta"><span>The Mechanism</span><span>...</span></div>',
      '    <div class="progress-bar"><div class="progress-fill" style="width:' + progress + '%"></div></div>',
      '  </div>',
      '  <div class="quiz-body">',
      '    <div class="edu">',
      '      <div class="edu-badge"><span class="dot"></span>' + esc(data.badge) + '</div>',
      '      <h1 class="q-title" style="font-size:26px">' + (data.label || '') + '</h1>',
      '      <p class="q-sub">GLP-1 medications amplify 5 biological triggers. Single-ingredient fixes address one.</p>',
      '      <div class="trigger-list" style="display:flex;flex-direction:column;gap:10px;margin-top:16px">',
      data.triggers.map(function (t, i) {
        return '<div class="trigger-row" data-trigger-index="' + i + '" style="opacity:0;transform:translateX(-20px)">' +
          '<div class="trigger-img">' + imgTag(t.img, t.name) + '<span class="trigger-num">' + t.n + '</span></div>' +
          '<div class="trigger-meta"><div class="t-name">' + esc(t.name) + '</div><div class="t-txt">' + esc(t.txt) + '</div></div>' +
          '</div>';
      }).join(''),
      '      </div>',
      '    </div>',
      '  </div>',
      '  <div class="quiz-footer">',
      '    <button class="btn-primary" data-action="next" disabled>Continue the diagnostic <span class="arrow">\u2192</span></button>',
      '  </div>',
      '</div>',
    ].join('');
  }

  /* ============== ANALYZING ============== */
  function viewAnalyzing() {
    return [
      '<div class="quiz-shell">',
      '  <div class="analyze-stage">',
      '    <div class="analyze-ring">',
      '      <svg viewBox="0 0 180 180">',
      '        <circle cx="90" cy="90" r="78" stroke="var(--cream-3)" stroke-width="4" fill="none"></circle>',
      '        <circle class="analyze-progress-arc" cx="90" cy="90" r="78" stroke="var(--orange)" stroke-width="4" fill="none" stroke-dasharray="' + (2 * Math.PI * 78) + '" stroke-dashoffset="' + (2 * Math.PI * 78) + '" stroke-linecap="round" transform="rotate(-90 90 90)"></circle>',
      '      </svg>',
      '      <div class="pct">0%</div>',
      '    </div>',
      '    <div style="font-family:var(--serif);font-size:22px;font-style:italic;color:var(--ink);margin-bottom:20px">Building your protocol\u2026</div>',
      '    <div class="analyze-steps" style="width:100%;max-width:300px">',
      [
        'Mapping your cortisol profile\u2026',
        'Calculating GAS6 signal disruption\u2026',
        'Evaluating nutrient depletion\u2026',
        'Scoring anchor protein integrity\u2026',
        'Matching your 90-day protocol\u2026',
      ].map(function (s, i) {
        return '<div class="analyze-step" data-step-i="' + i + '"><span class="bullet"></span><span>' + esc(s) + '</span></div>';
      }).join(''),
      '    </div>',
      '  </div>',
      '</div>',
    ].join('');
  }

  /* ============== RESULTS HELPERS ============== */
  function computeProfile(answers) {
    var stress = answers.stress || 2;
    var shedding = answers.shedding || 2;
    var duration = answers.duration;
    var goal = answers.goal;

    var name = 'The Stress-Thinner';
    var subtitle = 'Cortisol is suffocating your follicles... and your shot is amplifying it.';
    var blurb = [
      'Chronic cortisol pushes follicles into a <strong>premature resting phase</strong>, where they stop growing and start shedding weeks later. GLP-1 medications compound this by spiking stress hormones during rapid fat loss.',
      'Your protocol is built around <strong>Shoden\u00ae ashwagandha to drop cortisol within 30 days</strong>, paired with <strong>keraGEN-IV\u00ae</strong> to rebuild the strands you\'re losing... so you keep the weight loss without paying for it in the mirror.',
    ];
    var primaryIngredients = ['ashwagandha', 'keratin', 'vitamins'];

    if (goal === 'keep-shot') {
      name = 'The Trade-Off';
      subtitle = 'You love your results. Your hair is the price... but it doesn\'t have to be.';
      blurb = [
        'You\'ve made it clear: <strong>the shot stays.</strong> That means your hair loss isn\'t a "pause the medication" problem... it\'s a <strong>protect the follicle</strong> problem.',
        'Your protocol works alongside GLP-1s, neutralizing the <strong>7 specific triggers</strong> (cortisol surge, anchor breakdown, toxin load, nutrient depletion, sleep/recovery debt, follicle oxidation, hormonal shift) <strong>without interfering with the medication</strong>. You keep your transformation <em>and</em> your hair.',
      ];
      primaryIngredients = ['keratin', 'ashwagandha', 'zeropollution'];
    } else if (shedding >= 4) {
      name = 'The Shedder';
      subtitle = 'You\'re in the peak shedding window. We need to rebuild your follicle anchors now.';
      blurb = [
        'Handfuls in the shower means your follicles have <strong>already lost grip on the strand</strong>... the anchor proteins (keratin and collagen IV) that hold each hair in place are breaking down faster than your body can rebuild them. <strong>Every week without intervention compounds the loss.</strong>',
        'Your protocol leads with <strong>keraGEN-IV\u00ae and Shoden\u00ae</strong> at clinical doses... <strong>Shoden\u00ae drops cortisol in 60 days</strong> and <strong>keraGEN-IV\u00ae rebuilds anchor proteins</strong> so the shedding cycle has a chance to reset.',
      ];
      primaryIngredients = ['keratin', 'biotin', 'ashwagandha'];
    } else if (duration === '3to6') {
      name = 'The Cliff Edge';
      subtitle = 'You\'re at the 3\u20136 month cliff. The shedding surge is coming. Let\'s get ahead of it.';
      blurb = [
        '<strong>Month 3 to 6 on a GLP-1</strong> is when most women hit the shedding cliff... the cortisol-and-nutrient debt from rapid weight loss finally catches up to your follicles, and what feels like a normal hair fall suddenly becomes clumps.',
        'Starting now means you <strong>intercept the surge before it becomes visible thinning</strong>, instead of trying to recover from it 6 months from now. <strong>Pre-emptive is 3\u00d7 more effective than reactive.</strong>',
      ];
      primaryIngredients = ['ashwagandha', 'keratin', 'vitamins'];
    } else if (stress >= 3) {
      name = 'The Stress-Thinner';
      subtitle = 'Cortisol is suffocating your follicles... and your shot is amplifying the damage.';
      blurb = [
        'Your stress score and shedding pattern point to a <strong>cortisol-driven hair loss cycle</strong>: elevated stress hormones force follicles into resting phase, and the metabolic load of GLP-1 weight loss keeps pouring fuel on the fire.',
        'Single-ingredient fixes (biotin, collagen) miss the root cause entirely. Your protocol is anchored by <strong>Shoden\u00ae ashwagandha... clinically shown to lower cortisol 66%</strong>... so the rest of the formula can actually do its job.',
      ];
      primaryIngredients = ['ashwagandha', 'vitamins', 'keratin'];
    }

    var medMap = { ozempic: 'Ozempic', wegovy: 'Wegovy', mounjaro: 'Mounjaro', zepbound: 'Zepbound', other: 'GLP-1' };
    var durMap = { lt3: 'under 3 months', '3to6': '3\u20136 months', '6to12': '6\u201312 months', gt12: 'over a year' };
    var durTagMap = { lt3: 'pre-shedding window', '3to6': 'peak shedding window', '6to12': 'chronic phase', gt12: 'long-term phase' };
    var shedLabelMap = { 1: 'Mild shedding', 2: 'Slightly elevated shedding', 3: 'Noticeable shedding', 4: 'Heavy shedding \u00b7 handfuls', 5: 'Severe shedding \u00b7 clumps' };
    var partTagMap = { alot: 'visible scalp at the part', yes: 'visibly wider part', slight: 'slightly wider part', no: 'density still intact' };
    var stressLabelMap = { 1: 'Manageable stress', 2: 'Moderate stress', 3: 'High stress', 4: 'Through-the-roof cortisol' };
    var weightLabelMap = { '<15': 'Under 15 lbs lost', '15-30': '15\u201330 lbs lost', '30-50': '30\u201350 lbs lost', '50+': 'Over 50 lbs lost' };
    var sleepLabelMap = { good: 'Sleeping deeply', ok: 'Decent 6\u20137 hr sleep', broken: 'Broken sleep', bad: 'Sleep-deprived' };

    var personalBullets = [];
    if (answers.glp1 && answers.duration) {
      personalBullets.push({ label: 'On ' + (medMap[answers.glp1] || 'GLP-1') + ' for ' + durMap[answers.duration], tag: durTagMap[answers.duration] });
    }
    if (answers.shedding) {
      personalBullets.push({ label: shedLabelMap[answers.shedding] || 'Active shedding', tag: partTagMap[answers.part] || 'tracking density loss' });
    }
    if (answers.stress || answers.weight || answers.sleep) {
      var left = stressLabelMap[answers.stress];
      var right = weightLabelMap[answers.weight] || sleepLabelMap[answers.sleep];
      var parts = [left, right].filter(Boolean);
      if (parts.length) {
        personalBullets.push({ label: parts.join(' \u00b7 '), tag: (answers.stress || 0) >= 3 ? 'cortisol blocking GAS6' : 'metabolic load on follicles' });
      }
    }

    return { name: name, subtitle: subtitle, blurb: blurb, primaryIngredients: primaryIngredients, personalBullets: personalBullets.slice(0, 3) };
  }

  function computeTriggers(answers) {
    var s = answers.shedding || 1;
    var st = answers.stress || 1;
    var sl = answers.sleep === 'bad' ? 4 : answers.sleep === 'broken' ? 3 : answers.sleep === 'ok' ? 2 : 1;
    var w = answers.weight === '50+' ? 4 : answers.weight === '30-50' ? 3 : answers.weight === '15-30' ? 2 : 1;
    var p = answers.part === 'alot' ? 4 : answers.part === 'yes' ? 3 : answers.part === 'slight' ? 2 : 1;
    var a = answers.age === '55+' ? 4 : answers.age === '45-54' ? 3 : answers.age === '35-44' ? 2 : 1;
    var rows = [
      { name: 'The Cortisol Crash', score: 40 + st * 15, tag: 'Stress hormone shutting down growth', stat: 'Spikes during rapid fat loss', what: 'Stress hormones spike when your body is rapidly losing fat. Cortisol blocks GAS6, the molecule that tells your follicles to keep growing... so they shut down and shed.', fix: 'Shoden\u00ae ashwagandha lowers cortisol 66% in 60 days.' },
      { name: 'The Slipping Strands', score: 30 + s * 10 + p * 8, tag: 'Strands sliding out at the root', stat: 'Keratin loss accelerates', what: 'The keratin and collagen IV proteins that hold each strand into your scalp are breaking down faster than your body rebuilds them... so healthy-looking hairs slide out.', fix: 'keraGEN-IV\u00ae rebuilds the anchor proteins at the root.' },
      { name: 'The Detox Dump', score: 30 + w * 16, tag: 'Stored toxins flooding your scalp', stat: 'Released during fat loss', what: 'Rapid fat loss dumps stored toxins back into your bloodstream. They circulate to your scalp and create oxidative chaos around the follicles.', fix: 'zeropollution\u00ae clinically protects scalp cells from pollution-induced oxidative damage.' },
      { name: 'The Nutrient Drain', score: 45 + w * 10, tag: 'Follicles starved of fuel', stat: 'Iron, zinc, biotin low', what: 'Eating less means your body diverts iron, zinc, biotin, and protein to vital organs first. Your follicles, nails, and skin starve before anything else.', fix: 'Clinical doses of biotin, zinc, copper restore the supply.' },
      { name: 'The Sleep Debt', score: 30 + sl * 15, tag: 'Repair cycle interrupted', stat: 'Deep sleep rebuilds keratin', what: 'Follicles rebuild keratin during deep sleep. Broken or short sleep means weaker strands and slower regrowth, day after day.', fix: 'Shoden\u00ae improves sleep depth and recovery cycles.' },
      { name: 'The Oxidative Burn', score: 35 + Math.max(st, s) * 12, tag: 'Free radicals damaging new hair', stat: 'Growth cycles lost', what: 'Oxidative stress damages the cells that make new hair. The longer it goes unchecked, the more growth cycles you lose.', fix: 'Vitamins C + E shield follicles from free radical damage.' },
      { name: 'The Estrogen Cliff', score: 28 + a * 14, tag: 'Estrogen drop amplifying loss', stat: 'DHT sensitivity rising', what: 'Estrogen drops with age and amplifies follicle sensitivity to cortisol and DHT. GLP-1 weight loss accelerates the hormonal rollercoaster.', fix: 'Multi-pathway formula stabilizes the follicle environment.' },
    ];
    return rows.map(function (t) { return Object.assign({}, t, { score: Math.min(94, t.score) }); });
  }

  var INGREDIENTS = [
    { key: 'keratin', match: 'keratin', img: IMG.ig_keratin, name: 'keraGEN-IV\u00ae Keratin', dose: 'In 770mg proprietary blend', claim: 'Clinically shown to cut hair fall 43.1% vs placebo at 60 days.', why: 'Rebuilds the anchor proteins your follicles need to hold each strand in place.', benefits: ['Brush and shower drains start clearing', 'Thicker, more resilient new growth', 'Hairline density fills back in'] },
    { key: 'ashwagandha', match: 'ashwagandha', img: IMG.ig_ashwagandha, name: 'Shoden\u00ae Ashwagandha', dose: 'In 770mg proprietary blend', claim: 'Drops cortisol 66% in 60 days... the stress hormone GLP-1s spike that drives your shed.', why: 'Calms the cortisol-driven follicle shutdown so growth signals can switch back on.', benefits: ['Deeper sleep, fewer 3am wakeups', 'Less reactive scalp and skin', 'Follicles re-enter the growth phase'] },
    { key: 'zeropollution', match: 'zeropollution', img: IMG.ig_zeropollution, name: 'zeropollution\u00ae Botanicals', dose: 'In 770mg proprietary blend', claim: 'Patented antioxidant complex clinically shown to shield scalp cells from pollution-driven oxidative damage.', why: 'Mops up the toxins your body releases from rapid fat loss before they damage follicles.', benefits: ['Calmer roots, less itch and irritation', 'Protects new growth during rapid weight loss', 'Scalp feels lighter and less inflamed'] },
    { key: 'biotin', match: 'biotin', img: IMG.ig_biotin, name: 'Biotin', dose: '2,500 mcg per day \u00b7 8,333% DV', claim: 'Direct building block your follicles use to assemble keratin... at 80x daily value to overcome appetite-driven gaps.', why: 'The B vitamin your hair runs on. Low biotin shows up as brittle, slow-growing strands.', benefits: ['Stronger nail beds and cuticles', 'Faster, more even regrowth', 'Less breakage on washing'] },
    { key: 'pantothenic', match: 'biotin', img: IMG.ig_pantothenic, name: 'Pantothenic Acid (B5)', dose: '100 mg per day \u00b7 2,000% DV', claim: 'Foundational B vitamin involved in coenzyme A and the fatty acids that condition your scalp.', why: 'Replenishes the B vitamin most easily depleted by appetite suppression, alongside biotin.', benefits: ['Softer, smoother hair texture', 'Reduced scalp dryness', 'Better shine without weighing strands down'] },
    { key: 'zinc', match: 'biotin', img: IMG.ig_zinc, name: 'Zinc', dose: '15 mg per day \u00b7 136% DV', claim: 'Cofactor in over 100 enzymatic reactions tied to hair growth and tissue repair.', why: 'Low zinc is one of the most-cited mineral deficiencies in clinical hair-loss patients.', benefits: ['Supports new follicle activity', 'Strengthens the hair shaft', 'Calms a flaky, irritated scalp'] },
    { key: 'copper', match: 'biotin', img: IMG.ig_copper, name: 'Copper', dose: '1.7 mg per day \u00b7 189% DV', claim: 'Required for melanin synthesis and the cross-links that give hair its tensile strength.', why: 'GLP-1 weight loss often pairs zinc loss with copper loss... we replace both in balance.', benefits: ['Helps preserve natural hair color', 'Stronger strand structure', 'Supports collagen formation'] },
    { key: 'vitamin_c', match: 'vitamins', img: IMG.ig_vitamin_c, name: 'Vitamin C', dose: '90 mg per day \u00b7 100% DV', claim: 'Required cofactor in collagen synthesis... no vitamin C, no new follicle scaffolding.', why: 'Recycles vitamin E so the antioxidant system keeps running during rapid weight loss.', benefits: ['Stronger follicle structure', 'Brighter, more even skin tone', 'Better iron absorption from food'] },
    { key: 'vitamin_e', match: 'vitamins', img: IMG.ig_vitamin_e, name: 'Vitamin E', dose: '100 mg per day \u00b7 667% DV', claim: 'Lipid-soluble antioxidant proven to protect cell membranes from oxidative damage.', why: 'Sits in the scalp\'s lipid layer guarding follicle membranes from the toxin surge.', benefits: ['Protects new growth from breakage', 'Maintains the scalp barrier', 'Supports circulation to follicles'] },
  ];

  var FAQ_ITEMS = [
    { q: 'How long before I see results?', a: "Most women notice reduced shedding within the first 2 to 3 weeks as antioxidants begin neutralizing oxidative damage and ashwagandha starts lowering cortisol. By week 6 to 8, you'll feel the difference... hair texture improves, breakage decreases. The most dramatic transformation happens at 60 to 90 days, which aligns with a complete hair growth cycle. In the keraGEN-IV\u00ae clinical trial, women experienced a 43.1% reduction in hair loss at 60 days." },
    { q: 'Is KeraLush safe to take alongside my GLP-1?', a: 'KeraLush is 100% drug-free vitamins, minerals, and botanicals... no hormones, no harsh chemicals, no synthetic compounds. There are no known interactions with GLP-1 medications like Ozempic, Wegovy, Mounjaro, or Zepbound. Every ingredient has been tested for safety and every batch is third-party tested for purity at NSF and GMP certified facilities. We always recommend mentioning any new supplement to the prescriber managing your GLP-1, especially if you\'ve had recent dose changes.' },
    { q: 'Can I take this with other supplements or medications?', a: "KeraLush is formulated to complement most supplement regimens. That said, if you're taking prescription medications... particularly blood thinners, thyroid medication, hormone replacement therapy, or immunosuppressants... we recommend consulting your healthcare provider first. Your doctor knows your complete health picture and can confirm there are no contraindications specific to your situation." },
    { q: "What if it doesn't work for me?", a: "We stand behind the science with a 90-day money-back guarantee. If you don't experience noticeable improvements in hair thickness, reduced shedding, or overall hair vitality, contact us at support@rejuveen.com for a full refund... no questions asked. You can keep any unopened bottles. We've seen the clinical data. We know this works for the vast majority of women. But bodies are unique, and we respect that." },
    { q: 'Why is KeraLush better than just taking biotin?', a: "Biotin addresses one piece of the puzzle... nutrient deficiency. But GLP-1-related hair loss tends to be multifactorial. There's rapid weight loss spiking cortisol and disrupting GAS6 signaling. There's appetite suppression that can leave follicles short on zinc, copper, and B vitamins. And there's the toxin load released from rapid fat loss. KeraLush is designed to address several of these mechanisms together, which is why women often see more improvement than from single-ingredient biotin alone." },
    { q: 'How is this different from minoxidil or prescription treatments?', a: "Minoxidil is a topical vasodilator that increases blood flow to the scalp. It doesn't address the underlying biology driving GLP-1-related shedding. KeraLush works from the inside out, targeting the nutritional and cortisol-related drivers. Many women use both together. Unlike prescription DHT blockers like finasteride (which carry hormonal side-effect risks and aren't FDA-approved for women), KeraLush is 100% drug-free and hormone-neutral, and is generally well tolerated." },
    { q: 'Do I need to take this forever?', a: "For optimal results, ongoing use is best. The triggers that damage your follicles... chronic stress, environmental pollution, hormonal fluctuations, ongoing GLP-1 use... are persistent. They don't stop just because you've completed 90 days. Continuous nutritional support helps your body maintain the improvements you've achieved. That said, many women find their hair stays healthier for months even after stopping, unlike topical treatments that require lifelong daily application." },
    { q: 'Is this only for women on GLP-1s?', a: 'KeraLush was specifically formulated to address the hormonal, inflammatory, and nutritional mechanisms driving hair loss in women on GLP-1s, but younger women experiencing stress-induced shedding, postpartum hair loss, or early-onset thinning benefit significantly as well. The clinical ingredients work regardless of age because they target universal biological pathways. If your follicles are under stress, these nutrients provide support.' },
    { q: "What's the best way to take KeraLush?", a: "Take 2 capsules daily with a meal... preferably breakfast or lunch... and a full glass of water. Consistency matters more than timing, so pick a time you'll remember and stick with it. Pro tip: avoid taking KeraLush with coffee or calcium supplements, as both can interfere with nutrient absorption. And give it the full 60 to 90 days. Hair regrowth is a biological process. You're rebuilding follicle health from the cellular level up." },
    { q: 'Can I use this if I have thyroid issues or PCOS?', a: "Many women with thyroid dysfunction or PCOS use KeraLush successfully. In fact, hormonal imbalances are among the primary drivers of hair loss in both conditions. The adaptogenic properties of Shoden\u00ae ashwagandha can help support healthy cortisol balance, and the antioxidants protect follicles. However, if you're on thyroid medication (levothyroxine) or metformin, please consult your endocrinologist before starting. Timing of supplementation may need adjustment to avoid interference with medication absorption." },
    { q: "What makes the ingredients in KeraLush 'clinical-strength'?", a: "Clinical-strength means we use the exact forms and dosages tested in published human trials. Our keraGEN-IV\u00ae keratin is the same form that achieved a 43.1% reduction in hair loss in a double-blind, placebo-controlled study. Our zeropollution\u00ae blend delivers the antioxidant complex shown to protect scalp cells from pollution-driven oxidative damage. We don't use fairy-dusted amounts. Every ingredient is dosed to deliver the results seen in the research." },
  ];

  var TIMELINE = [
    { week: 'WEEK 1\u20132', phase: 'Foundation Phase', detail: 'Shedding slows. Ashwagandha lowers cortisol. Antioxidants neutralize toxin surge from your weight loss.' },
    { week: 'WEEK 3\u20136', phase: 'Strengthening', detail: 'Hairbrush clears up. keraGEN-IV\u00ae rebuilds disulfide bonds. Breakage drops. Scalp feels lighter.' },
    { week: 'WEEK 7\u201312', phase: 'Clinical Window', detail: 'keraGEN-IV\u00ae hits its clinical mark: 43.1% less hair fall vs placebo at 60 days.' },
    { week: 'WEEK 12+', phase: 'Full Cycle Complete', detail: 'Ingredients have had a full hair-growth cycle to work. All on your shot, without quitting.' },
  ];

  var FAILURES = [
    { n: 'Biotin gummies', w: 'Solves nutrient gap only. Ignores cortisol, anchor proteins, and oxidation entirely.' },
    { n: 'Collagen powder', w: 'Generic Type I collagen... your follicles need Type IV at the anchor point. Wrong target.' },
    { n: 'Minoxidil and topicals', w: 'Pushes follicles to grow while the root cause keeps shutting them down. You shed harder when you stop.' },
    { n: '"Hair, skin & nails" multis', w: 'Sub-clinical doses spread across 30 ingredients. None hit the threshold to actually work.' },
    { n: 'Stopping the shot', w: "You'd lose the metabolic progress... and the cortisol crash from rebound weight gain often makes hair loss worse." },
  ];

  var TESTIMONIALS = [
    { img: IMG.port_1, headline: 'New baby hairs and visible new growth.', quote: "I have so many new baby hairs... NEW GROWTH. My curls are softer and shinier. I'm an official convert.", name: 'Nikki H.', detail: 'Down 38 lbs \u00b7 Ozempic' },
    { img: IMG.port_2, headline: 'The shedding stopped completely.', quote: "Three months on KeraLush and the shedding stopped completely. I didn't have to choose anymore.", name: 'Gigi', detail: 'Down 46 lbs \u00b7 Wegovy' },
    { img: IMG.port_3, headline: 'Breakage has noticeably decreased.', quote: 'My hair feels healthier, smoother, and more hydrated. Breakage has noticeably decreased.', name: 'Rachel W.', detail: 'Down 52 lbs \u00b7 Mounjaro' },
    { img: IMG.port_4, headline: 'New growth where I had thinned.', quote: 'Definitely noticed nail growth, better sleep, and new hair growth in spots that were menopausal thinning.', name: 'Kimberly', detail: 'Down 27 lbs \u00b7 Zepbound' },
  ];

  /* ============== RESULTS VIEW ============== */
  function viewResults() {
    var profile = computeProfile(state.answers);
    var triggers = computeTriggers(state.answers);
    var p = PACKAGES.find(function (x) { return x.k === state.plan; }) || PACKAGES[0];

    var triggerCardsHtml = triggers.map(function (t, i) {
      var color = t.score >= 70 ? 'var(--orange)' : t.score >= 50 ? 'var(--orange-soft)' : 'var(--ink-3)';
      var risk = t.score >= 75 ? 'risk-critical' : t.score >= 60 ? 'risk-high' : t.score >= 45 ? 'risk-mod' : 'risk-low';
      var riskLabel = t.score >= 75 ? 'CRITICAL' : t.score >= 60 ? 'HIGH' : t.score >= 45 ? 'MODERATE' : 'LOW';
      var fillBg = t.score >= 70 ? 'var(--orange)' : 'var(--orange-soft)';
      return '<button type="button" class="trigger-card flip" data-trigger-card="' + i + '" aria-pressed="false" aria-label="' + esc(t.name + ': ' + Math.round(t.score) + ' percent... tap for details') + '">' +
        '<div class="flip-inner">' +
        '<div class="flip-face flip-front">' +
        '<div class="front-top">' +
        '<div class="score" style="color:' + color + '">' + Math.round(t.score) + '<span style="font-size:16px">%</span></div>' +
        '<div class="risk-pill ' + risk + '">' + riskLabel + '</div>' +
        '</div>' +
        '<div class="name">' + esc(t.name) + '</div>' +
        '<div class="tag">' + esc(t.tag) + '</div>' +
        '<div class="bar"><div class="bar-fill" style="width:' + t.score + '%;animation-delay:' + (i * 120) + 'ms;background:' + fillBg + '"></div></div>' +
        '<div class="front-foot"><span class="stat-line">' + esc(t.stat) + '</span><span class="flip-cue">Tap \u2192</span></div>' +
        '</div>' +
        '<div class="flip-face flip-back">' +
        '<div class="back-name">' + esc(t.name) + '</div>' +
        '<div class="back-what">' + esc(t.what) + '</div>' +
        '<div class="back-fix"><strong>Your protocol:</strong> ' + esc(t.fix) + '</div>' +
        '<div class="flip-cue back-cue">Tap to flip back</div>' +
        '</div>' +
        '</div></button>';
    }).join('');

    var failuresHtml = FAILURES.map(function (f) {
      return '<div class="failure-row">' +
        '<img class="failure-x" src="' + esc(IMG.x_mark) + '" alt="" loading="lazy">' +
        '<div class="failure-body"><div class="failure-name">' + esc(f.n) + '</div><div class="failure-why">' + esc(f.w) + '</div></div>' +
        '</div>';
    }).join('');

    var ingredientsHtml = INGREDIENTS.map(function (i) {
      var isPrimary = profile.primaryIngredients.indexOf(i.match) !== -1;
      return '<div class="ingredient-tile' + (isPrimary ? ' is-primary' : '') + '">' +
        '<div class="ig-img-real">' + imgTag(i.img, i.name) + '</div>' +
        '<div>' +
        '<div class="ig-name">' + esc(i.name) + (isPrimary ? ' <span class="ig-pill">For you</span>' : '') + '</div>' +
        '<div class="ig-dose">' + esc(i.dose) + '</div>' +
        '<div class="ig-claim">' + esc(i.claim) + '</div>' +
        (isPrimary ? '<div class="ig-why">' + esc(i.why) + '</div>' : '') +
        '<ul class="ig-benefits">' + i.benefits.map(function (b) { return '<li>' + esc(b) + '</li>'; }).join('') + '</ul>' +
        '</div></div>';
    }).join('');

    var timelineHtml = TIMELINE.map(function (t) {
      return '<div class="timeline-item"><div class="week">' + esc(t.week) + '</div><div class="phase">' + esc(t.phase) + '</div><div class="detail">' + esc(t.detail) + '</div></div>';
    }).join('');

    var reviewsHtml = TESTIMONIALS.map(function (t) {
      return '<div class="review-card">' +
        '<img src="' + esc(t.img) + '" alt="' + esc(t.name) + '" loading="lazy">' +
        '<div class="review-body"><div class="stars">\u2605\u2605\u2605\u2605\u2605</div>' +
        (t.headline ? '<h4 class="review-headline">' + esc(t.headline) + '</h4>' : '') +
        '<p>"' + esc(t.quote) + '"</p>' +
        '<div class="who-meta"><div class="name">' + esc(t.name) + '</div><div class="detail">' + esc(t.detail) + '</div></div>' +
        '</div></div>';
    }).join('');

    var personalBulletsHtml = profile.personalBullets.length ?
      '<ul class="personal-bullets">' + profile.personalBullets.map(function (b) {
        return '<li><span class="pb-check">\u2713</span><span class="pb-text"><span class="pb-label">' + esc(b.label) + '</span>' + (b.tag ? '<span class="pb-tag"> \u00b7 ' + esc(b.tag) + '</span>' : '') + '</span></li>';
      }).join('') + '</ul>' : '';

    var faqHtml = FAQ_ITEMS.map(function (item) {
      return '<details name="faq" class="faq-item"><summary class="faq-q"><span class="faq-q-text">' + esc(item.q) + '</span><span class="faq-icon" aria-hidden="true"></span></summary><div class="faq-a">' + esc(item.a) + '</div></details>';
    }).join('');

    var blurbHtml = profile.blurb.map(function (para) { return '<p>' + para + '</p>'; }).join('');

    return [
      '<div class="results" data-screen-label="Results">',
      '  <div class="results-hero" id="sec-top">',
      '    <div style="position:relative;z-index:2">',
      '      <div class="profile-badge">\u25cf YOUR PROFILE</div>',
      '      <h1 class="profile-name">' + esc(profile.name) + '</h1>',
      '      <p class="profile-sub">' + esc(profile.subtitle) + '</p>',
      personalBulletsHtml,
      '      <button class="pulse-arrow" data-action="scroll" data-target="sec-why" aria-label="See your personal protocol">',
      '        <span class="pa-label">See your personal protocol</span>',
      '        <span class="pa-chev">\u2193</span>',
      '      </button>',
      '    </div>',
      '  </div>',

      '  <div class="section" id="sec-why" style="padding-top:18px">',
      '    <div class="section-eyebrow">Why this is happening to you</div>',
      '    <div class="profile-blurb">' + blurbHtml + '</div>',
      '    <p class="why-flow">All of this is hitting your follicles at the <em>same time</em>. Below... the <strong>7 specific triggers</strong> your protocol has to neutralize.</p>',
      '  </div>',

      '  <div class="section" id="sec-triggers" style="padding-bottom:0">',
      '    <div class="section-eyebrow">Why you\'re shedding</div>',
      '    <h2>Your hair is being attacked from <em>7 directions at once.</em></h2>',
      '  </div>',
      '  <div class="trigger-hint">Tap any card to see what it means</div>',
      '  <div class="trigger-grid">' + triggerCardsHtml + '</div>',

      '  <div class="trigger-proof">',
      '    <div class="trigger-proof-eyebrow">What reversal looks like</div>',
      '    <div class="trigger-proof-h">When all 7 get fixed at once... <em>this is what happens.</em></div>',
      '    <div class="trigger-proof-img">',
      imgTag(IMG.intro_ba_hero, 'Dana R. before and after... hair restored after 18 weeks'),
      '      <span class="corner-tag corner-tag-l">WEEK 1</span>',
      '      <span class="corner-tag corner-tag-r">WEEK 18</span>',
      '    </div>',
      '    <div class="trigger-proof-cap">DANA R. \u00b7 9 MONTHS ON WEGOVY \u00b7 DOWN 52 LBS</div>',
      '  </div>',

      '  <div class="section-jump"><button data-action="scroll" data-target="sec-failures">See why nothing has worked yet \u2193</button></div>',

      '  <div class="section" id="sec-failures">',
      '    <div class="section-eyebrow">Why nothing has worked</div>',
      '    <h2>You\'ve tried things. <em>Here\'s why they failed.</em></h2>',
      '    <p class="section-intro">Single-ingredient fixes target one trigger. Your hair loss has 7. The math has never been on your side.</p>',
      '    <div class="failures">' + failuresHtml + '</div>',
      '  </div>',

      '  <div class="section" id="sec-meet" style="background:var(--cream)">',
      '    <div class="meet-hero">',
      '      <div class="section-eyebrow">Introducing</div>',
      '      <h2 class="meet-h">Rejuveen <em>KeraLush</em>... built for women on the shot.</h2>',
      '      <div class="meet-bottle-wrap">' + imgTag(IMG.bottle, 'Rejuveen KeraLush bottle', { class: 'meet-bottle-hero' }) + '</div>',
      '      <p class="section-intro meet-intro">The first multi-pathway formula designed specifically for GLP-1-driven hair loss. Five clinical ingredients. Seven biological triggers. One capsule, twice a day.</p>',
      '    </div>',
      '    <div class="meet-benefits">',
      '      <div class="benefit-row"><div class="benefit-num">01</div><div class="benefit-body"><div class="benefit-name">Lowers cortisol at the root</div><div class="benefit-why">Shoden\u00ae ashwagandha drops cortisol 66% in 60 days... your follicles wake back up.</div></div></div>',
      '      <div class="benefit-row"><div class="benefit-num">02</div><div class="benefit-body"><div class="benefit-name">Rebuilds the anchor</div><div class="benefit-why">keraGEN-IV\u00ae delivers keratin and Type IV collagen so strands stay locked in.</div></div></div>',
      '      <div class="benefit-row"><div class="benefit-num">03</div><div class="benefit-body"><div class="benefit-name">Neutralizes the toxin dump</div><div class="benefit-why">zeropollution\u00ae clears 80% of scalp oxidative particles released during fat loss.</div></div></div>',
      '      <div class="benefit-row"><div class="benefit-num">04</div><div class="benefit-body"><div class="benefit-name">Refills the depleted nutrients</div><div class="benefit-why">Clinical doses of biotin, zinc, copper, and vitamins C + E... not sprinkle amounts.</div></div></div>',
      '      <div class="benefit-row"><div class="benefit-num">05</div><div class="benefit-body"><div class="benefit-name">Works with your shot, not against it</div><div class="benefit-why">Formulated for GLP-1 metabolism. Keep the weight loss. Keep the hair.</div></div></div>',
      '    </div>',
      '    <div class="expert-quote">',
      '      <div class="expert-stars">\u2605\u2605\u2605\u2605\u2605</div>',
      '      <div class="expert-body">' + imgTag(IMG.megan, "Megan D'Andrea, RN", { class: 'expert-img' }) +
      '        <div class="expert-text">',
      '          <p>"A science-backed supplement that supports hair strength, shine, and growth. With biotin, keratin, and collagen, my hair feels stronger and more resilient even after ER shifts."</p>',
      '          <div class="expert-name">Megan D\'Andrea</div>',
      '          <div class="expert-title">RN, BSN, PCCN</div>',
      '        </div>',
      '      </div>',
      '    </div>',
      '  </div>',

      '  <div class="section" id="sec-gallery">',
      '    <div class="section-eyebrow">Real women \u00b7 real results</div>',
      '    <h2>Women with your <em>exact profile</em> saw this.</h2>',
      '    <div class="ba-grid">',
      '      <div class="ba-tile"><img src="' + esc(IMG.ba_1) + '" alt="Regrowth" loading="lazy"><div class="ba-cap">Temples restored</div></div>',
      '      <div class="ba-tile"><img src="' + esc(IMG.ba_4) + '" alt="Regrowth" loading="lazy"><div class="ba-cap">Less shedding</div></div>',
      '      <div class="ba-tile"><img src="' + esc(IMG.ba_2) + '" alt="Regrowth" loading="lazy"><div class="ba-cap">Shinier strands</div></div>',
      '      <div class="ba-tile"><img src="' + esc(IMG.ba_3) + '" alt="Regrowth" loading="lazy"><div class="ba-cap">New growth</div></div>',
      '    </div>',
      '  </div>',

      '  <div class="testimonial">',
      '    <span class="quote-mark">"</span>',
      '    <div class="q">I stayed on my shot because it changed my life. But KeraLush gave me my hair back. That\'s when I knew this was different.</div>',
      '    <div class="who"><img src="' + esc(IMG.port_1) + '" alt="Rachel" class="avatar-img" loading="lazy"><div class="who-meta"><div class="name">Rachel \u00b7 43</div><div class="detail">Down 52 lbs \u00b7 Same profile as you</div></div></div>',
      '  </div>',

      '  <div class="section" id="sec-timeline">',
      '    <div class="section-eyebrow">What to expect</div>',
      '    <h2>Here\'s what happens <em>on KeraLush.</em></h2>',
      '    <div class="timeline">' + timelineHtml + '</div>',
      '    <div class="section-jump" style="margin-top:20px"><button data-action="scroll" data-target="sec-ingredients">See the ingredients \u2193</button></div>',
      '  </div>',

      '  <div class="section" id="sec-ingredients" style="background:#fff;border-top:1px solid var(--line);border-bottom:1px solid var(--line)">',
      '    <div class="section-eyebrow">Your personalized 90-day protocol</div>',
      '    <h2>The ingredients <em>built for you.</em></h2>',
      '    <div style="margin-top:8px">' + ingredientsHtml + '</div>',
      '  </div>',

      '  <div class="section" id="sec-crossroads">',
      '    <div class="section-eyebrow">Your crossroads</div>',
      '    <h2>What are your <em>other options</em>... really?</h2>',
      '    <p class="section-intro">Two paths from here. One you already know. One that finally treats the cause.</p>',
      '    <div class="crossroads">',
      '      <div class="path path-a">',
      '        <div class="path-tag">PATH A</div>',
      '        <div class="path-title">Wait it out</div>',
      '        <ul class="path-list">',
      '          <li><span class="dot dot-bad"></span>Shedding gets worse before it gets better</li>',
      '          <li><span class="dot dot-bad"></span>6+ months of watching the part widen</li>',
      '          <li><span class="dot dot-bad"></span>Single-ingredient fixes keep failing</li>',
      '          <li><span class="dot dot-bad"></span>Quietly consider stopping the shot</li>',
      '          <li><span class="dot dot-bad"></span>Lose the metabolic progress too</li>',
      '        </ul>',
      '        <div class="path-foot path-foot-a">Same outcome. Just slower.</div>',
      '      </div>',
      '      <div class="path-or"><span>OR</span></div>',
      '      <div class="path path-b">',
      '        <div class="path-tag path-tag-b">PATH B</div>',
      '        <div class="path-title">Start your protocol</div>',
      '        <ul class="path-list">',
      '          <li><span class="dot dot-good"></span>Less shedding inside 30 days</li>',
      '          <li><span class="dot dot-good"></span>Anchor proteins rebuilt at the root</li>',
      '          <li><span class="dot dot-good"></span>Cortisol down 66% in 60 days</li>',
      '          <li><span class="dot dot-good"></span>Visible regrowth by month 3</li>',
      '          <li><span class="dot dot-good"></span>Keep the shot. Keep the hair.</li>',
      '        </ul>',
      '        <div class="path-foot path-foot-b">Backed by 90-day guarantee.</div>',
      '      </div>',
      '    </div>',
      '  </div>',

      '  <div class="pre-offer-cta">',
      '    <div class="poc-ey">Ready to start?</div>',
      '    <div class="poc-t">Your personalized 90-day protocol is waiting.</div>',
      '    <button class="btn-primary" data-action="scroll" data-target="offer-anchor">Claim my protocol <span class="arrow">\u2192</span></button>',
      '  </div>',
      '  <div id="offer-anchor" class="offer-wrap">',
      '    <div class="offer-progress">',
      [1, 2, 3].map(function (n) {
        var labels = { 1: 'Select', 2: 'Review', 3: 'Checkout' };
        var active = state.offerStep >= n;
        var current = state.offerStep === n;
        return '<div class="op-step' + (active ? ' active' : '') + (current ? ' current' : '') + '"><span class="op-num">' + (state.offerStep > n ? '\u2713' : n) + '</span><span class="op-lbl">' + labels[n] + '</span></div>';
      }).join(''),
      '    </div>',
      '    <div class="offer-step-content">' + viewOfferStep(state.offerStep, profile) + '</div>',
      '  </div>',

      '  <div class="section">',
      '    <div class="section-eyebrow">Trusted by 3M+ women</div>',
      '    <h2>Reviews from women on <em>the shot.</em></h2>',
      '    <div class="review-grid">' + reviewsHtml + '</div>',
      '  </div>',

      '  <div class="trust-section">',
      '    <div class="trust-card"><img src="' + esc(IMG.money_back) + '" alt="90-day guarantee" loading="lazy"><div><div class="trust-t">90-Day Money-Back Guarantee</div><div class="trust-d">If you don\'t see less shedding and more density, we\'ll refund every penny... even the empty bottles.</div></div></div>',
      '  </div>',

      '  <div class="order-summary">',
      '    <div class="os-eyebrow">Here\'s what\'s waiting</div>',
      '    <h3 class="os-title">Your <em>' + esc(profile.name) + '</em> protocol</h3>',
      '    <div class="os-card">',
      '      <div class="os-card-head">' + imgTag(IMG.bottle, 'KeraLush bottle', { class: 'os-bottle' }) + '<div class="os-head-txt"><div class="os-product">Rejuveen KeraLush</div><div class="os-tagline">90-day starter protocol \u00b7 60 capsules</div></div></div>',
      '      <ul class="os-benefits">',
      '        <li><span class="os-tick">\u2713</span><span><strong>Targets the 7 GLP-1 + cortisol triggers at the source.</strong> Not one... all 7.</span></li>',
      '        <li><span class="os-tick">\u2713</span><span><strong>A cleaner pillow inside 30 days.</strong> Less in the shower drain. Less wrapped around the brush.</span></li>',
      '        <li><span class="os-tick">\u2713</span><span><strong>Cuts hair fall nearly in half by month 2.</strong> Clinical trial, 60 days, keraGEN-iV\u2122... not another gummy promise.</span></li>',
      '        <li><span class="os-tick">\u2713</span><span><strong>Calms the cortisol driving the shed.</strong> Real sleep again. Less lying awake at 3am doing the math on your hairline.</span></li>',
      '        <li><span class="os-tick">\u2713</span><span><strong>By month 3, your hair growth cycle has had a full reset window.</strong> Powered by clinical doses of keratin, biotin, zinc, and copper.</span></li>',
      '        <li><span class="os-tick">\u2713</span><span><strong>Keep every pound you\'ve earned.</strong> Zero known interactions with your shot. You don\'t have to choose between your body and your hair.</span></li>',
      '      </ul>',
      '      <div class="os-reminders">',
      '        <div class="os-reminder"><span class="os-rem-ico">\u26e8</span><div><strong>90-day money-back guarantee.</strong> Even the empty bottles.</div></div>',
      '        <div class="os-reminder"><span class="os-rem-ico">\u21ba</span><div><strong>Cancel or pause anytime.</strong> No phone calls, no friction.</div></div>',
      '        <div class="os-reminder"><span class="os-rem-ico">\u25a6</span><div><strong>Free US shipping</strong> on 2+ bottles.</div></div>',
      '      </div>',
      '      <button class="btn-primary os-cta" data-action="scroll" data-target="offer-anchor">Start my 90-day protocol <span class="arrow">\u2192</span></button>',
      '      <div class="os-fine">No email required to see your results \u00b7 Reviewed by endocrine RNs</div>',
      '    </div>',
      '  </div>',

      '  <div class="trust-row"><span>As seen in</span><span>VOGUE</span><span>\u00b7</span><span>FORBES</span><span>\u00b7</span><span>WOMEN\'S HEALTH</span></div>',

      '  <section class="faq" id="sec-faq">',
      '    <div class="faq-eyebrow">FAQ</div>',
      '    <h3 class="faq-title">Frequently asked questions</h3>',
      '    <div class="faq-list">' + faqHtml + '</div>',
      '  </section>',

      '  <div class="final-cta">',
      '    <div class="final-cta-eyebrow">Ready when you are</div>',
      '    <h3>Stop the shedding. <em>Keep the shot.</em></h3>',
      '    <p>Your "' + esc(profile.name) + '" protocol is waiting. Most women see less shedding inside 30 days.</p>',
      '    <button class="btn-primary final-cta-btn" data-action="scroll" data-target="offer-anchor">Start my protocol \u2192</button>',
      '    <div class="final-cta-foot">90-day money-back guarantee \u00b7 Free shipping</div>',
      '  </div>',

      '  <div class="fine">*Results vary. Statistics from published peer-reviewed clinical studies on keraGEN-IV\u00ae, Shoden\u00ae, and zeropollution\u00ae. These statements have not been evaluated by the FDA. This product is not intended to diagnose, treat, cure or prevent any disease.</div>',

      '  <div style="padding:0 24px 40px;text-align:center"><button class="btn-primary btn-ghost" data-action="restart">Retake the quiz</button></div>',
      '</div>',
    ].join('');
  }

  /* ============== OFFER STEP VIEWS ============== */
  function viewOfferStep(step, profile) {
    if (step === 1) return viewOfferStep1();
    if (step === 2) return viewOfferStep2();
    return viewOfferStep3(profile);
  }

  function viewOfferStep1() {
    var packsHtml = PACKAGES.map(function (p) {
      var isFeatured = p.k === '90';
      var isStarter = p.k === '30';
      var has10Off = p.k === '90' || p.k === '60';
      var sel = state.plan === p.k;
      var ctaLabel = isFeatured
        ? 'Start my 90-day hair transformation'
        : 'Continue to my order';
      return '<button data-action="select-plan" data-plan="' + esc(p.k) + '" class="offer-pack' + (sel ? ' selected' : '') + (isFeatured ? ' featured' : '') + (isStarter ? ' starter' : '') + '">' +
        (p.badge ? '<span class="pack-badge' + (isFeatured ? ' gold' : '') + '">' + esc(p.badge) + '</span>' : '') +
        (isFeatured ? '<span class="pack-savings">SAVE $90</span>' : '') +
        '<div class="pack-main">' +
        '<div class="pack-img">' + imgTag(p.bundle, p.months) + '</div>' +
        '<div class="pack-meta">' +
        '<div class="pack-months">' + esc(p.months) + '</div>' +
        '<div class="pack-per">' + esc(p.per) + '<span class="pack-per-unit">/day</span></div>' +
        '<div class="pack-price-row"><span class="pack-total">$' + p.total + ' total</span><span class="pack-strike">$' + p.strike + '</span><span class="pack-save">Save ' + p.save + '%</span></div>' +
        (has10Off ? '<div class="pack-coupon-inline"><span class="pc-tag">+ EXTRA $10 OFF</span><span class="pc-txt">auto-applied at checkout</span></div>' : '') +
        (isStarter ? '<div class="pack-warn">Recommended for return customers. A full 90-day hair cycle is recommended for first-time results.</div>' : '') +
        '</div>' +
        '<div class="pack-radio"><span></span></div>' +
        '</div>' +
        (has10Off ? '<div class="pack-coupon"><span class="pc-tag">+ EXTRA $10 OFF</span><span class="pc-txt">auto-applied at checkout</span></div>' : '') +
        (isFeatured ? '<div class="pack-extras">' +
          '<div class="pack-extras-title">Everything in the 90-day protocol:</div>' +
          '<ul class="pack-extras-list">' +
          '<li><span class="pe-tick">\u2713</span>3 bottles, one full hair-growth cycle... no gaps, no restarting</li>' +
          '<li><span class="pe-tick">\u2713</span><strong>Free US shipping</strong> + priority dispatch</li>' +
          '<li><span class="pe-tick">\u2713</span>Pause or cancel anytime, no phone calls</li>' +
          '</ul>' +
          '<div class="pack-social"><span class="ps-dot"></span><strong>Most women start here</strong> for full-cycle results</div>' +
          '</div>' : '') +
        (sel ? '<span role="button" tabindex="0" class="btn-primary pack-cta pack-cta-inline" data-action="offer-next">' + esc(ctaLabel) + ' <span class="arrow">\u2192</span></span>' : '') +
        '</button>';
    }).join('');

    return [
      '<div class="offer-step" data-screen-label="Offer \u00b7 Step 1">',
      '  <div class="offer-header">',
      '    <div class="offer-step-badge">STEP 1 OF 3 \u00b7 SELECT YOUR SUPPLY</div>',
      '    <h2 class="offer-h">Choose your <em>transformation plan</em></h2>',
      '    <p class="offer-sub">Hair grows on a 90-day cycle. To give the formula a full window to work, you need three full bottles. Most women start here for full-cycle results.</p>',
      '  </div>',
      '  <div class="why90">',
      '    <div class="why90-title">WHY 90 DAYS IS THE PROTOCOL</div>',
      '    <div class="why90-row">',
      '      <div class="why90-step"><div class="why90-num">30</div><div class="why90-label">Shedding slows</div><div class="why90-sub">Cleaner pillow, less in the drain.</div></div>',
      '      <div class="why90-arrow">\u2192</div>',
      '      <div class="why90-step"><div class="why90-num">60</div><div class="why90-label">Hair fall cut nearly in half</div><div class="why90-sub">End of the clinical trial window.</div></div>',
      '      <div class="why90-arrow">\u2192</div>',
      '      <div class="why90-step highlight"><div class="why90-num">90</div><div class="why90-label">Full hair-growth cycle complete</div><div class="why90-sub">Ingredients have had time to do their work.</div></div>',
      '    </div>',
      '  </div>',
      '  <div class="offer-packs">' + packsHtml + '</div>',
      '  <div class="offer-perks">',
      '    <div class="perk"><span class="pk">\u2713</span> 90-day money-back guarantee... even the empty bottles</div>',
      '    <div class="perk"><span class="pk">\u2713</span> Free US shipping on 2+ bottles</div>',
      '    <div class="perk"><span class="pk">\u2713</span> Made in FDA-registered, GMP-certified US facility</div>',
      '    <div class="perk"><span class="pk">\u2713</span> Zero known interactions with GLP-1 medications</div>',
      '  </div>',
      '  <button class="btn-primary" data-action="offer-next">Continue to my order <span class="arrow">\u2192</span></button>',
      '  <div class="offer-foot">SSL secured checkout \u00b7 256-bit encryption</div>',
      '</div>',
    ].join('');
  }

  function viewOfferStep2() {
    var p = PACKAGES.find(function (x) { return x.k === state.plan; });
    return [
      '<div class="offer-step" data-screen-label="Offer \u00b7 Step 2">',
      '  <div class="offer-header">',
      '    <div class="offer-step-badge">STEP 2 OF 3 \u00b7 REVIEW YOUR ORDER</div>',
      '    <h2 class="offer-h">Your personalized <em>hair protocol</em></h2>',
      '  </div>',
      '  <div class="order-card">',
      '    <div class="order-top">',
      '      <div class="order-img">' + imgTag(p.bundle, p.months) + '</div>',
      '      <div class="order-info"><div class="order-name">KeraLush\u2122</div><div class="order-months">' + esc(p.months) + ' \u00b7 ' + p.bottles + ' ' + (p.bottles === 1 ? 'bottle' : 'bottles') + '</div><div class="order-per">' + esc(p.per) + ' per serving</div></div>',
      '      <div class="order-price"><div class="op-total">$' + p.total + '</div><div class="op-strike">$' + p.strike + '</div></div>',
      '    </div>',
      '    <div class="order-line"></div>',
      '    <div class="order-rows">',
      '      <div class="or"><span>Subtotal</span><span>$' + p.strike + '.00</span></div>',
      '      <div class="or"><span>Your ' + p.save + '% discount</span><span style="color:var(--orange)">\u2212$' + (p.strike - p.total) + '.00</span></div>',
      '      <div class="or"><span>Shipping</span><span>' + (p.bottles >= 2 ? 'FREE' : '$4.95') + '</span></div>',
      '      <div class="or total"><span>Total</span><span>$' + p.total + '.00</span></div>',
      '    </div>',
      '  </div>',
      '  <div class="order-includes">',
      '    <div class="oi-title">Included with your order:</div>',
      '    <div class="oi-row"><img src="' + esc(IMG.money_back) + '" alt="" loading="lazy"><div>90-day money-back guarantee</div></div>',
      '    <div class="oi-row"><span class="oi-icon">\u2726</span><div>Free access to our GLP-1 hair care guide (digital)</div></div>',
      '    <div class="oi-row"><span class="oi-icon">\u26a1</span><div>Priority customer support from our wellness team</div></div>',
      '  </div>',
      '  <button class="btn-primary" data-action="offer-next">Continue to checkout <span class="arrow">\u2192</span></button>',
      '  <button class="btn-text" data-action="offer-back">\u2190 Change my plan</button>',
      '</div>',
    ].join('');
  }

  function viewOfferStep3(profile) {
    var p = PACKAGES.find(function (x) { return x.k === state.plan; });
    return [
      '<div class="offer-step" data-screen-label="Offer \u00b7 Step 3">',
      '  <div class="offer-header">',
      '    <div class="offer-step-badge">STEP 3 OF 3 \u00b7 SECURE YOUR ORDER</div>',
      '    <h2 class="offer-h">Where should we <em>send your protocol?</em></h2>',
      '    <p class="offer-sub">We\'ll email your results PDF and begin shipping immediately.</p>',
      '  </div>',
      '  <div class="checkout-form">',
      '    <label class="fld"><span>First name</span><input type="text" name="first_name" placeholder="Jane" autocomplete="given-name"></label>',
      '    <label class="fld"><span>Email address</span><input type="email" name="email" placeholder="jane@example.com" autocomplete="email"></label>',
      '  </div>',
      '  <div class="mini-summary">',
      '    <div class="ms-row">' + imgTag(p.bundle, '') + '<div><div class="ms-name">KeraLush\u2122 \u00b7 ' + esc(p.months) + '</div><div class="ms-sub">90-day guarantee \u00b7 Free shipping</div></div><div class="ms-price">$' + p.total + '</div></div>',
      '  </div>',
      '  <button class="btn-primary btn-checkout" data-action="checkout">\u{1f512} Complete order... $' + p.total + '</button>',
      '  <div class="trust-line"><span>SECURE</span><span>\u00b7</span><span>256-BIT</span><span>\u00b7</span><span>STRIPE / SHOP PAY</span></div>',
      '  <div class="pay-row"><span>VISA</span><span>MC</span><span>AMEX</span><span>PAYPAL</span><span>APPLE PAY</span><span>G PAY</span></div>',
      '  <button class="btn-text" data-action="offer-back">\u2190 Back</button>',
      '  <div class="final-reassurance"><div class="ur-title">You\'re protected.</div><p>If KeraLush doesn\'t visibly reduce your shedding within 90 days, we refund every penny. You can even keep the empty bottles. That\'s how confident we are in the science.</p></div>',
      '</div>',
    ].join('');
  }

  /* ============== RENDER ============== */
  function render() {
    var root = getRoot();
    if (!root) return;
    var cur = STEPS[state.step];
    var inner;
    if (cur.type === 'intro') inner = viewIntro();
    else if (cur.type === 'q') inner = viewQuestion(QUESTIONS[cur.idx], cur.idx, QUESTIONS.length);
    else if (cur.type === 'edu1') inner = viewEduStat(EDUCATION.stat1, questionsSeenBeforeHere() - 1, QUESTIONS.length);
    else if (cur.type === 'edu2') inner = viewEduTriggers(EDUCATION.stat2, questionsSeenBeforeHere() - 1, QUESTIONS.length);
    else if (cur.type === 'edu3') inner = viewEduStat(EDUCATION.stat3, questionsSeenBeforeHere() - 1, QUESTIONS.length);
    else if (cur.type === 'analyze') inner = viewAnalyzing();
    else if (cur.type === 'results') inner = viewResults();

    var isResults = cur.type === 'results';
    var logo = (CFG.images && CFG.images.logo) || '';
    var ribbon = '<div class="brand-ribbon">' + (logo ? '<img src="' + esc(logo) + '" alt="Rejuveen">' : '<span style="color:#fff;font-family:var(--serif);font-style:italic;font-size:18px">rejuveen</span>') + '</div>';
    root.innerHTML = '<div class="phone-frame' + (isResults ? ' scroll' : '') + '">' + ribbon + inner + '</div>';

    afterRender(cur);
    persistState();
    scrollToTop();
  }

  function questionsSeenBeforeHere() {
    var count = 0;
    for (var i = 0; i < state.step; i++) {
      if (STEPS[i].type === 'q') count++;
    }
    return count;
  }

  /* ============== POST-RENDER WIRING ============== */
  function afterRender(cur) {
    if (cur.type === 'intro') wireIntro();
    else if (cur.type === 'edu1' || cur.type === 'edu3') wireEduStat();
    else if (cur.type === 'edu2') wireEduTriggers();
    else if (cur.type === 'analyze') wireAnalyzing();
    else if (cur.type === 'results') wireResults();
  }

  function wireIntro() {
    var sticky = document.querySelector('#keralush-quiz-root .sticky-cta');
    if (!sticky) return;
    var onScroll = function () {
      if (window.scrollY > 120) sticky.removeAttribute('hidden');
      else sticky.setAttribute('hidden', '');
    };
    if (window.__keralushScrollHandler) window.removeEventListener('scroll', window.__keralushScrollHandler);
    window.addEventListener('scroll', onScroll, { passive: true });
    window.__keralushScrollHandler = onScroll;
    onScroll();
  }

  function wireEduStat() {
    var hero = document.querySelector('#keralush-quiz-root [data-count-target]');
    if (!hero) return;
    var target = parseFloat(hero.getAttribute('data-count-target'));
    var suffix = hero.querySelector('.pct');
    var t0 = null;
    var dur = 1600;
    var raf;
    function tick(t) {
      if (!t0) t0 = t;
      var p = Math.min(1, (t - t0) / dur);
      var v = target * (1 - Math.pow(1 - p, 3));
      var formatted = v.toFixed(1).replace('.0', '');
      hero.firstChild.nodeValue = formatted;
      if (p < 1) raf = requestAnimationFrame(tick);
    }
    if (suffix) {
      // make sure first child is the text node
      hero.firstChild.nodeValue = '0';
    }
    raf = requestAnimationFrame(tick);
  }

  function wireEduTriggers() {
    var rows = document.querySelectorAll('#keralush-quiz-root .trigger-row');
    var nextBtn = document.querySelector('#keralush-quiz-root .quiz-footer .btn-primary');
    if (!rows.length) return;
    var i = 0;
    function reveal() {
      if (i < rows.length) {
        rows[i].style.transition = 'all 500ms cubic-bezier(.16,1,.3,1)';
        rows[i].style.opacity = '1';
        rows[i].style.transform = 'translateX(0)';
        i++;
        setTimeout(reveal, 420);
      } else if (nextBtn) {
        nextBtn.removeAttribute('disabled');
      }
    }
    setTimeout(reveal, 200);
  }

  function wireAnalyzing() {
    var arc = document.querySelector('#keralush-quiz-root .analyze-progress-arc');
    var pctEl = document.querySelector('#keralush-quiz-root .analyze-ring .pct');
    var stepEls = document.querySelectorAll('#keralush-quiz-root .analyze-step');
    if (!arc || !pctEl) return;
    var circ = 2 * Math.PI * 78;
    var dur = 5200;
    var t0 = performance.now();
    var raf;
    function tick(t) {
      var p = Math.min(1, (t - t0) / dur);
      var pct = Math.round(p * 100);
      pctEl.textContent = pct + '%';
      arc.setAttribute('stroke-dashoffset', circ * (1 - p));
      var stepIdx = Math.min(stepEls.length - 1, Math.floor(p * stepEls.length));
      stepEls.forEach(function (s, i) {
        s.classList.remove('active', 'done');
        if (i < stepIdx) s.classList.add('done');
        else if (i === stepIdx) s.classList.add('active');
      });
      if (p < 1) raf = requestAnimationFrame(tick);
      else setTimeout(function () {
        state.step = Math.min(state.step + 1, STEPS.length - 1);
        render();
      }, 400);
    }
    raf = requestAnimationFrame(tick);
  }

  var quizCompleteFired = false;
  function wireResults() {
    if (quizCompleteFired) return;
    quizCompleteFired = true;
    track('QuizComplete', {
      content_name: computeProfile(state.answers).name,
      glp1_medication: state.answers.glp1,
      glp1_duration: state.answers.duration,
      shedding_level: state.answers.shedding,
    });
  }

  /* ============== EVENT DELEGATION ============== */
  function onClick(e) {
    var target = e.target.closest('[data-action]');
    if (!target) {
      // Trigger card click (no data-action; uses data-trigger-card)
      var card = e.target.closest('[data-trigger-card]');
      if (card) {
        var idx = parseInt(card.getAttribute('data-trigger-card'), 10);
        var nowFlipped = card.classList.contains('is-flipped');
        document.querySelectorAll('#keralush-quiz-root .trigger-card.is-flipped').forEach(function (c) {
          if (c !== card) {
            c.classList.remove('is-flipped');
            c.setAttribute('aria-pressed', 'false');
          }
        });
        card.classList.toggle('is-flipped', !nowFlipped);
        card.setAttribute('aria-pressed', String(!nowFlipped));
      }
      return;
    }
    var action = target.getAttribute('data-action');

    if (action === 'start') {
      track('QuizStart', { content_name: 'hair_diagnostic_quiz' });
      state.step = Math.min(state.step + 1, STEPS.length - 1);
      render();
      return;
    }

    if (action === 'next') {
      state.step = Math.min(state.step + 1, STEPS.length - 1);
      render();
      return;
    }

    if (action === 'back') {
      state.step = Math.max(state.step - 1, 0);
      render();
      return;
    }

    if (action === 'restart') {
      state.answers = {};
      state.step = 0;
      state.plan = '90';
      state.offerStep = 1;
      quizCompleteFired = false;
      render();
      return;
    }

    if (action === 'answer-radio') {
      var v = target.getAttribute('data-value');
      var qNow = QUESTIONS[STEPS[state.step].idx];
      var castVal = (qNow.id === 'stress') ? parseInt(v, 10) : v;
      state.answers[qNow.id] = castVal;
      persistState();
      // Toggle selection in place (no full re-render)... avoids re-running screenIn
      document.querySelectorAll('#keralush-quiz-root .options .option').forEach(function (o) {
        o.classList.remove('selected');
        var ck = o.querySelector('.check');
        if (ck) ck.textContent = '';
      });
      target.classList.add('selected');
      var ckTarget = target.querySelector('.check');
      if (ckTarget) ckTarget.textContent = '\u2713';
      setTimeout(function () {
        state.step = Math.min(state.step + 1, STEPS.length - 1);
        render();
      }, 320);
      return;
    }

    if (action === 'answer-severity') {
      var sv = parseInt(target.getAttribute('data-value'), 10);
      var qNow2 = QUESTIONS[STEPS[state.step].idx];
      state.answers[qNow2.id] = sv;
      persistState();
      document.querySelectorAll('#keralush-quiz-root .severity-cell').forEach(function (o) { o.classList.remove('selected'); });
      target.classList.add('selected');
      setTimeout(function () {
        state.step = Math.min(state.step + 1, STEPS.length - 1);
        render();
      }, 360);
      return;
    }

    if (action === 'answer-pills') {
      var pv = target.getAttribute('data-value');
      var qNow3 = QUESTIONS[STEPS[state.step].idx];
      state.answers[qNow3.id] = pv;
      persistState();
      document.querySelectorAll('#keralush-quiz-root .pill').forEach(function (o) { o.classList.remove('selected'); });
      target.classList.add('selected');
      setTimeout(function () {
        state.step = Math.min(state.step + 1, STEPS.length - 1);
        render();
      }, 320);
      return;
    }

    if (action === 'answer-chip') {
      var cv = target.getAttribute('data-value');
      var qNow4 = QUESTIONS[STEPS[state.step].idx];
      var arr = (state.answers[qNow4.id] || []).slice();
      var on = arr.indexOf(cv) !== -1;
      if (cv === 'nothing') {
        state.answers[qNow4.id] = on ? [] : ['nothing'];
      } else {
        if (on) arr = arr.filter(function (x) { return x !== cv; });
        else arr = arr.filter(function (x) { return x !== 'nothing'; }).concat([cv]);
        state.answers[qNow4.id] = arr;
      }
      persistState();
      // Update chip visuals + footer hint + Continue button enabled state without full re-render
      var selected = state.answers[qNow4.id] || [];
      document.querySelectorAll('#keralush-quiz-root .chips .chip').forEach(function (c) {
        var v = c.getAttribute('data-value');
        var isOn = selected.indexOf(v) !== -1;
        c.classList.toggle('selected', isOn);
        var x = c.querySelector('.x');
        if (isOn && !x) c.insertAdjacentHTML('beforeend', ' <span class="x">\u2713</span>');
        else if (!isOn && x) x.remove();
      });
      var continueBtn = document.querySelector('#keralush-quiz-root .quiz-footer .btn-primary');
      var hint = document.querySelector('#keralush-quiz-root .quiz-footer .footer-hint');
      var canContinue = selected.length > 0;
      if (continueBtn) {
        if (canContinue) continueBtn.removeAttribute('disabled');
        else continueBtn.setAttribute('disabled', '');
      }
      if (hint) hint.style.display = canContinue ? 'none' : '';
      return;
    }

    if (action === 'select-plan') {
      state.plan = target.getAttribute('data-plan');
      persistState();
      var packs = document.querySelectorAll('#keralush-quiz-root .offer-packs .offer-pack');
      for (var i = 0; i < packs.length; i++) {
        var pk = packs[i];
        var isSelected = (pk === target || pk.getAttribute('data-plan') === state.plan);
        pk.classList.toggle('selected', isSelected);
        var existingCta = pk.querySelector(':scope > .pack-cta-inline');
        if (isSelected) {
          if (!existingCta) {
            var planKey = pk.getAttribute('data-plan');
            var ctaLabel = planKey === '90'
              ? 'Start my 90-day hair transformation'
              : 'Continue to my order';
            pk.insertAdjacentHTML('beforeend',
              '<span role="button" tabindex="0" class="btn-primary pack-cta pack-cta-inline" data-action="offer-next">' +
              esc(ctaLabel) + ' <span class="arrow">→</span></span>');
          }
        } else if (existingCta) {
          existingCta.remove();
        }
      }
      return;
    }

    if (action === 'offer-next') {
      state.offerStep = Math.min(state.offerStep + 1, 3);
      updateOfferStep();
      return;
    }

    if (action === 'offer-back') {
      state.offerStep = Math.max(state.offerStep - 1, 1);
      updateOfferStep();
      return;
    }

    if (action === 'scroll') {
      scrollToId(target.getAttribute('data-target'));
      return;
    }

    if (action === 'checkout') {
      runCheckout();
      return;
    }
  }

  function onBlur(e) {
    if (e.target && e.target.matches && e.target.matches('input[name="email"]')) {
      var emailInput = e.target;
      var nameInput = document.querySelector('#keralush-quiz-root input[name="first_name"]');
      var trimmed = (emailInput.value || '').trim();
      if (!trimmed || trimmed.indexOf('@') === -1) return;

      var profile = computeProfile(state.answers);
      var p = PACKAGES.find(function (x) { return x.k === state.plan; });

      klaviyoIdentify({
        $email: trimmed,
        $first_name: (nameInput && nameInput.value) || undefined,
        quiz_profile: profile && profile.name,
        glp1_medication: state.answers.glp1,
        glp1_duration: state.answers.duration,
        shedding_level: state.answers.shedding,
      });

      if (!hasLeadFired()) {
        markLeadFired();
        track('Lead', {
          content_name: profile && profile.name,
          content_category: 'quiz_email_capture',
          value: p.total,
          currency: 'USD',
        });
      }
    }
  }

  function runCheckout() {
    var profile = computeProfile(state.answers);
    var p = PACKAGES.find(function (x) { return x.k === state.plan; }) || PACKAGES[0];
    var nameInput = document.querySelector('#keralush-quiz-root input[name="first_name"]');
    var emailInput = document.querySelector('#keralush-quiz-root input[name="email"]');
    var firstName = nameInput ? nameInput.value : '';
    var email = emailInput ? emailInput.value : '';

    var discountCode = CFG.discountCode || '';
    var discountParam = discountCode ? ('?discount=' + encodeURIComponent(discountCode)) : '';

    var eventParams = {
      content_ids: [String(p.variantId)],
      content_name: profile.name,
      content_type: 'product',
      contents: [{ id: String(p.variantId), quantity: 1 }],
      currency: 'USD',
      value: p.total,
      num_items: p.bottles,
    };

    track('AddToCart', eventParams);
    track('InitiateCheckout', eventParams);

    /* Permalink-only flow (mirrors the subscription path in price-table.liquid:
       /cart/clear?return_to=/cart/add?...&return_to=/checkout). Replaces the
       previous fetch chain (cart/clear.js -> cart/add.js -> cart/update.js)
       with a single same-tab navigation. Shopify decodes return_to once at
       each step, so encodeURIComponent on the inner URL is what we want.

       Quiz answers ride along as line-item properties on the /cart/add step
       and surface on the line item in the Shopify Admin order. */
    var quizProps = {
      'Quiz Profile': profile.name,
      'GLP-1 Medication': state.answers.glp1 || '',
      'GLP-1 Duration': state.answers.duration || '',
      'Shedding Level': state.answers.shedding != null ? String(state.answers.shedding) : '',
      'First Name': firstName,
      'Email': email,
    };
    var propsQuery = '';
    Object.keys(quizProps).forEach(function (key) {
      var val = quizProps[key];
      if (!val) return;
      propsQuery += '&properties[' + encodeURIComponent(key) + ']=' + encodeURIComponent(val);
    });

    var addUrl = '/cart/add'
      + '?id=' + encodeURIComponent(p.variantId)
      + '&quantity=1'
      + propsQuery
      + '&return_to=' + encodeURIComponent('/checkout' + discountParam);

    var permalink = '/cart/clear?return_to=' + encodeURIComponent(addUrl);
    window.location.href = permalink;
  }

  /* ============== INIT ============== */
  function init() {
    var root = getRoot();
    if (!root) return;
    document.addEventListener('click', onClick);
    document.addEventListener('blur', onBlur, true);
    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
